const nl: Record<string, string> = {
  // Navigation - Dashboard
  "nav.dashboard": "Dashboard",
  "nav.orders": "Bestellingen",
  "nav.planning": "Planning",
  "nav.invoices": "Facturen",
  "nav.inbox": "Berichtenbox",
  "nav.addresses": "Adresboek",
  "nav.shop": "Shop",
  "nav.addons": "Add-ons",
  "nav.settings": "Instellingen",
  "nav.help": "Help & Support",
  "nav.admin": "Beheerdersportaal",
  "nav.newOrder": "Nieuwe bestelling",
  "nav.logout": "Uitloggen",
  "nav.theme": "Thema",
  "nav.backToAccount": "Terug naar eigen account",

  // Navigation - Public
  "nav.solutions": "Oplossingen",
  "nav.faq": "FAQ",
  "nav.about": "Over ons",
  "nav.contact": "Contact",
  "nav.kennisbank": "Kennisbank",

  // Blog
  "blog.backToOverview": "Terug naar kennisbank",
  "blog.relatedArticles": "Meer artikelen",
  "nav.login": "Inloggen",
  "nav.order": "Bestellen",

  // Dashboard page
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Welkom terug",
  "dashboard.activeOrders": "Actieve bestellingen",
  "dashboard.pendingInvoices": "Openstaande facturen",
  "dashboard.totalShipments": "Totaal zendingen",
  "dashboard.recentOrders": "Recente bestellingen",
  "dashboard.viewAll": "Bekijk alles",
  "dashboard.noOrders": "Nog geen bestellingen",
  "dashboard.startOrder": "Plaats je eerste bestelling",

  // Orders page
  "orders.title": "Mijn bestellingen",
  "orders.subtitle": "Bekijk en beheer al je bestellingen.",
  "orders.search": "Zoek op bestelnummer, bedrijf...",
  "orders.allStatuses": "Alle statussen",
  "orders.noOrders": "Geen bestellingen gevonden",
  "orders.adjustSearch": "Pas je zoekopdracht aan.",
  "orders.firstOrder": "Je hebt nog geen bestellingen geplaatst.",
  "orders.newOrder": "Nieuwe bestelling",
  "orders.orderDetails": "Bestelgegevens",
  "orders.origin": "Herkomst",
  "orders.destination": "Bestemming",
  "orders.product": "Product",
  "orders.dryIce": "Droogijs",
  "orders.packaging": "Verpakking",
  "orders.shipping": "Verzending",
  "orders.price": "Prijs",
  "orders.total": "Totaal",
  "orders.exclVat": "excl. BTW",
  "orders.inclVat": "incl. BTW",
  "orders.vat": "BTW",
  "orders.trackShipment": "Volg je zending via Track & Trace",
  "orders.reviewOrder": "Beoordeel deze bestelling",
  "orders.yourReview": "Jouw beoordeling",
  "orders.orderDate": "Besteldatum",
  "orders.pickupDate": "Ophaaldatum",
  "orders.deliveryDate": "Verwachte levering",
  "orders.carrier": "Vervoerder",
  "orders.trackingCode": "Trackingcode",
  "orders.specialInstructions": "Speciale instructies",

  // Order statuses
  "status.draft": "Concept",
  "status.submitted": "Ingediend",
  "status.confirmed": "Bevestigd",
  "status.in_production": "In productie",
  "status.ready": "Klaar",
  "status.shipped": "Onderweg",
  "status.completed": "Afgeleverd",
  "status.cancelled": "Geannuleerd",

  // Invoices page
  "invoices.title": "Facturen",
  "invoices.subtitle": "Bekijk en download je facturen en betalingsgeschiedenis.",
  "invoices.paid": "Betaald",
  "invoices.pending": "Openstaand",
  "invoices.total": "Totaal",
  "invoices.history": "Factuurhistorie",
  "invoices.search": "Zoek op factuurnummer, bedrijf...",
  "invoices.allStatuses": "Alle statussen",
  "invoices.filterStatus": "Filter op status",
  "invoices.invoiceNumber": "Factuurnummer",
  "invoices.date": "Datum",
  "invoices.destination": "Bestemming",
  "invoices.amount": "Bedrag",
  "invoices.status": "Status",
  "invoices.openSince": "Open sinds",
  "invoices.actions": "Acties",
  "invoices.view": "Bekijken",
  "invoices.downloadPdf": "Download PDF",
  "invoices.pay": "Betalen",
  "invoices.noInvoices": "Geen facturen gevonden",
  "invoices.adjustSearch": "Pas je zoekopdracht aan.",
  "invoices.firstInvoice": "Je hebt nog geen bestellingen met facturen. Plaats je eerste bestelling om te beginnen.",
  "invoices.payInvoice": "Factuur Betalen",
  "invoices.chooseMethod": "Kies een betaalmethode om deze factuur te voldoen.",
  "invoices.bankTransfer": "Overmaken per bank",
  "invoices.accountHolder": "Rekeninghouder",
  "invoices.bank": "Bank",
  "invoices.reference": "Omschrijving",
  "invoices.bankInfo": "Maak het bedrag over naar bovenstaand rekeningnummer onder vermelding van het factuurnummer. Na ontvangst wordt de factuur automatisch op betaald gezet.",
  "invoices.or": "OF",
  "invoices.onlinePayment": "Online betalen",
  "invoices.payOnline": "Online betalen via iDEAL",
  "invoices.close": "Sluiten",
  "invoices.downloaded": "Factuur gedownload",
  "invoices.downloadFailed": "Download mislukt",
  "invoices.downloadError": "Er ging iets mis bij het downloaden van de factuur.",
  "invoices.paymentSuccess": "Betaling succesvol",
  "invoices.paymentFailed": "Betaling mislukt",
  "invoices.copied": "Gekopieerd",
  "invoices.ibanCopied": "IBAN is gekopieerd naar klembord.",
  "invoices.invoiceCopied": "Factuurnummer is gekopieerd naar klembord.",
  "invoices.today": "Vandaag",
  "invoices.day": "dag",
  "invoices.days": "dagen",
  "invoices.open": "Open",
  "invoices.overdue": "Verlopen",
  "invoices.paidOn": "Betaald op",
  "invoices.statusOpen": "Open",
  "invoices.statusPaid": "Betaald",
  "invoices.statusOverdue": "Verlopen",

  // Inbox
  "inbox.title": "Berichten",
  "inbox.subtitle": "ongelezen",
  "inbox.subtitlePlural": "berichten",
  "inbox.subtitleSingular": "bericht",
  "inbox.noMessages": "Geen berichten",
  "inbox.noMessagesDesc": "Je hebt nog geen meldingen ontvangen.",
  "inbox.markRead": "Gelezen",
  "inbox.markUnread": "Ongelezen",
  "inbox.markAllRead": "Alles gelezen",
  "inbox.selected": "geselecteerd",
  "inbox.deselect": "Deselecteer",
  "inbox.selectAll": "Selecteer alles",
  "inbox.new": "Nieuw",

  // Addresses
  "addresses.title": "Adresboek",
  "addresses.subtitle": "Beheer je verzend- en factuuradressen.",
  "addresses.add": "Adres toevoegen",
  "addresses.edit": "Bewerken",
  "addresses.delete": "Verwijderen",
  "addresses.default": "Standaard",
  "addresses.setDefault": "Als standaard instellen",
  "addresses.noAddresses": "Geen adressen gevonden",

  // Settings
  "settings.title": "Instellingen",
  "settings.profile": "Profiel",
  "settings.company": "Bedrijf",
  "settings.team": "Team",
  "settings.language": "Taal",
  "settings.notifications": "Meldingen",
  "settings.save": "Opslaan",
  "settings.saving": "Opslaan...",
  "settings.saved": "Opgeslagen",
  "settings.savedDesc": "Je instellingen zijn bijgewerkt.",
  "settings.saveError": "Fout bij opslaan",
  "settings.personalInfo": "Persoonlijke gegevens",
  "settings.personalInfoDesc": "Je persoonlijke gegevens voor accountbeheer",
  "settings.firstName": "Voornaam",
  "settings.lastName": "Achternaam",
  "settings.email": "E-mailadres",
  "settings.emailReadonly": "E-mailadres kan niet worden gewijzigd",
  "settings.phone": "Telefoonnummer",
  "settings.companyInfo": "Bedrijfsgegevens",
  "settings.companyInfoDesc": "Bedrijfsgegevens voor facturatie en verzending",
  "settings.companyName": "Bedrijfsnaam",
  "settings.vatNumber": "BTW-nummer",
  "settings.kvkNumber": "KVK-nummer",
  "settings.billingEmail": "Facturatie e-mailadres",
  "settings.address": "Adres",
  "settings.houseNumber": "Huisnr.",
  "settings.city": "Plaats",
  "settings.postalCode": "Postcode",
  "settings.country": "Land",
  "settings.selectCountry": "Selecteer land",

  // Subscriptions / Planning
  "planning.title": "Planning",
  "planning.subtitle": "Beheer je terugkerende bestellingen en leveringen",
  "planning.noPlanning": "Geen actieve abonnementen",
  "planning.noPlanningDesc": "Wanneer je een terugkerende bestelling plaatst, verschijnt deze hier met de planning van je volgende leveringen.",
  "planning.frequency": "Frequentie",
  "planning.nextDelivery": "Volgende levering",
  "planning.firstDelivery": "Eerstvolgende levering",
  "planning.weekly": "Elke week",
  "planning.biweekly": "Elke 2 weken",
  "planning.monthly": "Elke 4 weken",
  "planning.upcomingDeliveries": "Komende leveringen",
  "planning.deliveryContents": "Inhoud levering",
  "planning.delivery": "Bezorging",
  "planning.perDelivery": "per levering",
  "planning.deliveries": "leveringen",
  "planning.modify": "Wijzigen",
  "planning.pause": "Pauzeren",
  "planning.resume": "Hervatten",
  "planning.lockDiscount": "Vastzetten met korting",
  "planning.stop": "Stopzetten",
  "planning.locked": "Vastgelegd",
  "planning.paused": "Gepauzeerd tot",
  "planning.discount": "korting",
  "planning.volumeDiscount": "Volumekorting beschikbaar",
  "planning.volumeDiscountDesc": "Zet je planning vast en profiteer van",
  "planning.volumeDiscountButton": "Gebruik de knop \"Vastzetten met korting\" bij je abonnement.",
  "planning.cancelTitle": "Abonnement stopzetten",
  "planning.cancelDesc": "Weet je zeker dat je dit abonnement wilt stopzetten? Toekomstige leveringen worden geannuleerd. Dit kan niet ongedaan worden gemaakt.",
  "planning.lockTitle": "Planning vastzetten",
  "planning.lockDesc": "Kies een volumekorting tier om je planning vast te leggen. Je krijgt korting op elke levering.",
  "planning.lock": "Vastzetten",
  "planning.currentPrice": "Huidige prijs",
  "planning.afterDiscount": "Na korting",
  "planning.pauseTitle": "Planning pauzeren",
  "planning.pauseDesc": "Kies een datum waarop de leveringen hervat moeten worden. Tot die datum worden er geen leveringen gepland.",
  "planning.resumePer": "Hervatten per",
  "planning.chooseDate": "Kies een datum",
  "planning.pausedUntilMsg": "Leveringen worden gepauzeerd tot",
  "planning.resumeAnytime": "Je kunt de planning op elk moment hervatten.",
  "planning.editTitle": "Planning wijzigen",
  "planning.editDesc": "Pas de planning en producten aan voor",
  "planning.schedule": "Planning",
  "planning.fixedDeliveryDay": "Vaste leverdag",
  "planning.interval": "Interval",
  "planning.products": "Producten",
  "planning.packagingSelect": "Selecteer verpakking",
  "planning.dryIceKg": "Droogijs (kg)",
  "planning.form": "Vorm",
  "planning.choose": "Kies",
  "planning.nextDeliveryLabel": "Eerstvolgende levering:",
  "planning.thenEvery": "Daarna elke",
  "planning.week": "week",
  "planning.weeks": "weken",
  "planning.on": "op",
  "planning.runsUntil": "Loopt tot",
  "planning.planningChanged": "Planning gewijzigd",
  "planning.planningChangedDesc": "De planning en producten zijn bijgewerkt.",
  "planning.planningPaused": "Planning gepauzeerd",
  "planning.planningPausedDesc": "Leveringen hervat vanaf",
  "planning.planningResumed": "Planning hervat",
  "planning.planningResumedDesc": "De leveringen zijn weer actief.",
  "planning.subCancelled": "Abonnement stopgezet",
  "planning.subCancelledDesc": "Je periodieke bestelling is geannuleerd.",
  "planning.planLocked": "Planning vastgelegd",
  "planning.planLockedDesc": "korting voor leveringen toegepast.",
  "planning.newOrder": "Nieuwe bestelling",
  "planning.weight": "Gewicht",
  "planning.temperature": "Temperatuur",
  "planning.carrier": "Vervoerder",
  "planning.timeSlot": "Tijdslot",
  "planning.destination": "Bestemming",
  "planning.total": "Totaal",
  "planning.pellets": "Pellets",
  "planning.slices": "Slices",
  "planning.blocks": "Blokken",
  "planning.monday": "Maandag",
  "planning.tuesday": "Dinsdag",
  "planning.wednesday": "Woensdag",
  "planning.thursday": "Donderdag",
  "planning.friday": "Vrijdag",
  "planning.sunday": "Zondag",
  "planning.saturday": "Zaterdag",

  // Orders detail
  "orders.productDetails": "Product Details",
  "orders.progress": "Voortgang",
  "orders.priceOverview": "Prijsoverzicht",
  "orders.inclPackaging": "incl. EPS Box",
  "orders.subtotalExclVat": "Subtotaal (excl. BTW)",
  "orders.totalInclVat": "Totaal (incl. BTW)",
  "orders.noPriceAvailable": "Geen prijs beschikbaar",
  "orders.orderedOn": "Besteld op",
  "orders.orderCancelled": "Bestelling geannuleerd",
  "orders.allTypes": "Alle types",
  "orders.epsDryIce": "EPS Droogijs",
  "orders.containerDryIce": "Container Droogijs",
  "orders.shipmentType": "Type verzending",
  "orders.orders": "Bestellingen",
  "orders.trackTrace": "Track & Trace",
  "orders.trackOrder": "Zending volgen",
  "orders.trackPlaceholder": "Bijv. ORD-240001 of 3SXXXX0000000",
  "orders.enterCode": "Voer je ordernummer of track & trace code in",
  "orders.lookingUp": "Zending opzoeken...",
  "orders.notFound": "Geen zending gevonden",
  "orders.notFoundDesc": "Controleer je code en probeer opnieuw.",
  "orders.orderNumber": "Ordernummer",
  "orders.orderDetails2": "Zendingsdetails",
  "orders.created": "Aangemaakt",
  "orders.trackTip": "Tip: Deel de",
  "orders.trackTipPage": "Track & Trace pagina",
  "orders.trackTipEnd": "met je ontvanger, zodat zij zonder inloggen de status van de zending kunnen volgen.",
  "orders.continue": "Verder",
  "orders.deleteConfirm": "Weet je zeker dat je dit concept wilt verwijderen?",
  "orders.copy": "Kopieer",
  "orders.view": "Bekijk",
  "orders.review": "Beoordeel",
  "orders.description": "Omschrijving",
  "orders.temperature": "Temperatuur",
  "orders.order": "Bestelling",

  // Onboarding
  "onboarding.companyDetails": "Bedrijfsgegevens",
  "onboarding.companyDescRequired": "Vul je bedrijfsgegevens in voordat je een bestelling kunt plaatsen.",
  "onboarding.companyDescOptional": "Vul je bedrijfsgegevens in om je profiel compleet te maken.",
  "onboarding.personalDetails": "Persoonlijke gegevens",
  "onboarding.personalDesc": "Controleer en vul je persoonlijke gegevens aan.",
  "onboarding.companyName": "Bedrijfsnaam *",
  "onboarding.postalCode": "Postcode *",
  "onboarding.houseNumber": "Huisnr. *",
  "onboarding.city": "Plaats",
  "onboarding.streetName": "Straatnaam *",
  "onboarding.country": "Land *",
  "onboarding.autoFill": "Wordt automatisch ingevuld",
  "onboarding.lookupFailed": "Geen adres gevonden. Vul straatnaam en plaats handmatig in.",
  "onboarding.fillLater": "Later invullen",
  "onboarding.next": "Volgende",
  "onboarding.firstName": "Voornaam *",
  "onboarding.lastName": "Achternaam *",
  "onboarding.email": "E-mailadres",
  "onboarding.emailLinked": "Gekoppeld aan je account",
  "onboarding.phone": "Telefoonnummer",
  "onboarding.back": "Terug",
  "onboarding.complete": "Voltooien",
  "onboarding.saving": "Bezig...",
  "onboarding.welcome": "Welkom!",
  "onboarding.welcomeDesc": "Je gegevens zijn opgeslagen.",
  "onboarding.saveError": "Fout bij opslaan",

  // Common
  "common.save": "Opslaan",
  "common.cancel": "Annuleren",
  "common.delete": "Verwijderen",
  "common.edit": "Bewerken",
  "common.add": "Toevoegen",
  "common.close": "Sluiten",
  "common.search": "Zoeken",
  "common.loading": "Laden...",
  "common.error": "Er ging iets mis",
  "common.success": "Gelukt",
  "common.confirm": "Bevestigen",
  "common.back": "Terug",
  "common.next": "Volgende",
  "common.previous": "Vorige",
  "common.yes": "Ja",
  "common.no": "Nee",
  "common.or": "of",
  "common.all": "Alle",
  "common.none": "Geen",
  "common.date": "Datum",
  "common.time": "Tijd",
  "common.status": "Status",
  "common.type": "Type",
  "common.description": "Omschrijving",
  "common.amount": "Bedrag",
  "common.price": "Prijs",
  "common.quantity": "Aantal",
  "common.total": "Totaal",
  "common.actions": "Acties",
  "common.details": "Details",
  "common.download": "Downloaden",
  "common.upload": "Uploaden",
  "common.print": "Afdrukken",
  "common.copy": "Kopiëren",
  "common.filter": "Filter",
  "common.sortBy": "Sorteren op",
  "common.noResults": "Geen resultaten",
  "common.showMore": "Meer tonen",
  "common.showLess": "Minder tonen",

  // Auth
  "auth.login": "Inloggen",
  "auth.signup": "Registreren",
  "auth.logout": "Uitloggen",
  "auth.email": "E-mailadres",
  "auth.password": "Wachtwoord",
  "auth.forgotPassword": "Wachtwoord vergeten?",
  "auth.resetPassword": "Wachtwoord herstellen",
  "auth.newPassword": "Nieuw wachtwoord",
  "auth.confirmPassword": "Bevestig wachtwoord",
  "auth.firstName": "Voornaam",
  "auth.lastName": "Achternaam",
  "auth.companyName": "Bedrijfsnaam",
  "auth.phone": "Telefoonnummer",
  "auth.noAccount": "Nog geen account?",
  "auth.hasAccount": "Heb je al een account?",
  "auth.createAccount": "Account aanmaken",
  "auth.loginTitle": "Log in op je account",
  "auth.signupTitle": "Maak een account aan",
  "auth.forgotTitle": "Wachtwoord vergeten",
  "auth.resetTitle": "Nieuw wachtwoord instellen",

  // Help
  "help.title": "Help & Support",
  "help.subtitle": "Hoe kunnen we je helpen?",
  "help.faq": "Veelgestelde vragen",
  "help.contact": "Neem contact op",

  // New Shipment wizard
  "wizard.title": "Nieuwe bestelling",
  "wizard.step1": "Type verzending",
  "wizard.step2": "Herkomst",
  "wizard.step3": "Bestemming",
  "wizard.step4": "Product",
  "wizard.step5": "Planning",
  "wizard.step6": "Overzicht",
  "wizard.placeOrder": "Bestelling plaatsen",
  "wizard.orderPlaced": "Bestelling succesvol geplaatst",

  // Landing page
  "landing.badge": "24/7 bereikbaar | Vers geproduceerd",
  "landing.heroTitle": "Vandaag besteld. Morgen droogijs op locatie.",
  "landing.heroSubtitle": "Vers, NEN-gecertificeerd biodroogijs. Bestel voor 12:00 en wij leveren morgen op locatie. Van 6 kg EPS-box tot pallet, voor horeca, farma, labs en logistiek.",
  "landing.ctaPrimary": "Direct bestellen",
  "landing.ctaContact": "Neem contact op",
  "landing.trustNen": "FSSC ISO 22000 gecertificeerd",
  "landing.trust247": "24/7 bereikbaar",
  "landing.trustDelivery": "Voor 12:00 besteld = morgen geleverd",
  "landing.trustFresh": "Droogijs uit bio CO₂",
  "landing.trustRate": "NEN-gecertificeerd droogijs",
  "landing.trustDedicated": "Snelle levering door heel NL",
  "landing.productsTitle": "Kies je product",
  "landing.productsSubtitle": "Selecteer het type verpakking dat bij je past en start direct met bestellen.",
  "landing.epsTitle": "EPS Box",
  "landing.epsDesc": "EPS isolatiebox gevuld met droogijs. Ideaal voor horeca, catering, laboratoria en dagelijks gebruik.",
  "landing.epsFeature1": "Lichtgewicht EPS isolatiebox",
  "landing.epsFeature2": "Pellets, schijven of blokken",
  "landing.epsFeature3": "Bezorging op je adres",
  "landing.epsOrder": "EPS Box bestellen",
  "landing.containerTitle": "Container",
  "landing.containerDesc": "Droogijs in bulk in geïsoleerde containers. Voor pharma, food productie en industrieel gebruik.",
  "landing.containerFeature1": "Langere houdbaarheid",
  "landing.containerFeature2": "Voor pharma, food & productie",
  "landing.containerFeature3": "Spoedlevering mogelijk",
  "landing.containerOrder": "Container bestellen",
  "landing.howTitle": "Hoe het werkt",
  "landing.howSubtitle": "In drie stappen droogijs besteld en geleverd.",
  "landing.step1Title": "Bestel online",
  "landing.step1Desc": "Kies je verpakking en hoeveelheid droogijs via ons bestelplatform. Geen account nodig.",
  "landing.step2Title": "Wij produceren vers",
  "landing.step2Desc": "Wij produceren je droogijs vers op de dag van levering voor maximale kwaliteit.",
  "landing.step3Title": "Snel bezorgd",
  "landing.step3Desc": "Je bestelling wordt snel en veilig bij je afgeleverd, door heel Nederland.",
  "landing.orderNow": "Nu bestellen",
  "landing.branchesTitle": "Voor elke branche een oplossing",
  "landing.branchesSubtitle": "Dutch DryIce levert aan uiteenlopende sectoren. Van horeca tot pharma | wij hebben de juiste oplossing.",
  "landing.branchHoreca": "Horeca & Catering",
  "landing.branchHorecaDesc": "Droogijs voor koeling van versproducten, evenementen en rookeffecten.",
  "landing.branchPharma": "Medisch & Farma",
  "landing.branchPharmaDesc": "Temperatuurgecontroleerde verzending van vaccins, monsters en medicijnen.",
  "landing.branchTransport": "Transport & Logistiek",
  "landing.branchTransportDesc": "Betrouwbare koeling tijdens transport van temperatuurgevoelige goederen.",
  "landing.branchFood": "Voedselindustrie",
  "landing.branchFoodDesc": "Bulk droogijs voor food processing, invriezen en voedselveiligheid.",
  "landing.branchCleaning": "Industrieel reinigen",
  "landing.branchCleaningDesc": "Droogijsstralen voor het reinigen van machines, mallen en oppervlakken.",
  "landing.branchEvents": "Evenementen",
  "landing.branchEventsDesc": "Spectaculaire rookeffecten en koeling voor evenementen en festivals.",
  "landing.whyTitle": "Waarom Dutch DryIce?",
  "landing.usp1Title": "FSSC ISO 22000 gecertificeerd biodroogijs",
  "landing.usp1Desc": "Ons droogijs is FSSC ISO 22000 gecertificeerd en geproduceerd uit bio CO₂. Wij zijn ook ISO 9001, 14001 en 22000 gecertificeerd.",
  "landing.usp2Title": "Snelle en betrouwbare levering",
  "landing.usp2Desc": "Vandaag besteld = morgen geleverd. Wij leveren door heel Nederland, van dinsdag t/m vrijdag.",
  "landing.usp3Title": "24/7 bereikbaar voor spoedorders",
  "landing.usp3Desc": "Onverwachte situaties? Wij zijn dag en nacht beschikbaar voor dringende bestellingen.",
  "landing.usp4Title": "Productiebedrijf met Ecovadis Bronze",
  "landing.usp4Desc": "Wij zijn een productiebedrijf, geen tussenhandel. Ons droogijs wordt dagelijks vers geproduceerd. Ecovadis Bronze gecertificeerd.",
  "landing.ctaTitle": "Direct droogijs bestellen?",
  "landing.ctaSubtitle": "Geen account nodig. Kies je product, vul je gegevens in en wij regelen de rest. Na je eerste bestelling krijg je automatisch toegang tot ons klantenportaal.",

  // Track & Trace
  "track.title": "Track & Trace",
  "track.subtitle": "Volg je zending in realtime.",
  "track.enterCode": "Voer je trackingcode in",
  "track.track": "Volgen",
  "track.noResults": "Geen zending gevonden",

  // Footer
  "footer.description": "Jouw partner in FSSC ISO 22000 gecertificeerd biodroogijs. Vers geproduceerd uit bio CO₂ en snel geleverd door heel Nederland.",
  "footer.copyright": "Alle rechten voorbehouden.",
  "footer.ordering": "Bestellen",
  "footer.epsOrder": "EPS Box bestellen",
  "footer.containerOrder": "Container bestellen",
  "footer.solutions": "Oplossingen",
  "footer.cities": "Droogijs kopen in:",
  "footer.contact": "Contact",
  "footer.available247": "24/7 bereikbaar",
  "footer.trackTrace": "Track & Trace",
  "footer.faq": "Veelgestelde vragen",
  "footer.aboutUs": "Over ons",
  "footer.login": "Inloggen",
  "footer.register": "Registreren",
  "footer.terms": "Algemene voorwaarden",
  "footer.privacy": "Privacybeleid",

  // Terms & Conditions
  "terms.title": "Algemene Voorwaarden",
  "terms.lastUpdated": "Laatst bijgewerkt",
  "terms.s1.title": "Artikel 1 | Definities",
  "terms.s1.p1": "In deze algemene voorwaarden wordt verstaan onder: 'Klant': iedere natuurlijke persoon of rechtspersoon die een bestelling plaatst of een overeenkomst aangaat via het platform. 'Bestelling': iedere opdracht tot levering van producten of diensten. 'Product': droogijs in alle vormen (pellets, blokken, plakken, slices) en bijbehorende verpakkingen zoals EPS-boxen en containers.",
  "terms.s1.p2": "'Platform': de website, het bestelportaal en alle bijbehorende digitale diensten waarop deze voorwaarden van toepassing zijn.",
  "terms.s2.title": "Artikel 2 | Toepasselijkheid",
  "terms.s2.p1": "Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes, bestellingen en overeenkomsten die via het platform tot stand komen, tenzij schriftelijk anders overeengekomen.",
  "terms.s2.p2": "Eventuele inkoop- of andere voorwaarden van de klant worden uitdrukkelijk van de hand gewezen. Afwijkingen van deze voorwaarden zijn slechts geldig indien schriftelijk bevestigd.",
  "terms.s3.title": "Artikel 3 | Bestellingen en overeenkomsten",
  "terms.s3.p1": "Een overeenkomst komt tot stand op het moment dat een bestelling schriftelijk (waaronder per e-mail of via het bestelportaal) wordt bevestigd, of feitelijk uitvoering wordt gegeven aan de bestelling.",
  "terms.s3.p2": "Prijzen zijn exclusief BTW, tenzij uitdrukkelijk anders vermeld. Prijzen kunnen worden gewijzigd bij gewijzigde marktomstandigheden, grondstofprijzen of overheidsmaatregelen.",
  "terms.s3.p3": "Bij abonnementsbestellingen gelden de op het moment van afsluiten overeengekomen prijzen en frequenties. Wijzigingen worden minimaal 30 dagen vooraf schriftelijk gecommuniceerd.",
  "terms.s4.title": "Artikel 4 | Levering en transport",
  "terms.s4.p1": "Er wordt gestreefd naar levering op de afgesproken datum en tijdvak. Opgegeven levertijden zijn indicatief en geen fatale termijnen. Overschrijding van de levertijd geeft de klant geen recht op schadevergoeding of ontbinding.",
  "terms.s4.p2": "Het risico van het product gaat over op de klant op het moment van levering op het opgegeven afleveradres. De klant is verantwoordelijk voor het verstrekken van correcte en volledige adresgegevens. Bij afwezigheid op het afleveradres kunnen extra kosten in rekening worden gebracht.",
  "terms.s5.title": "Artikel 5 | Veiligheid en gebruik",
  "terms.s5.p1": "Droogijs (vast CO₂) heeft een temperatuur van -78,5°C en vereist zorgvuldige omgang. De klant is verantwoordelijk voor het veilig gebruik, opslag en verwerking van droogijs conform de geldende veiligheidsrichtlijnen en het veiligheidsinformatieblad (SDS) dat bij elke levering beschikbaar wordt gesteld.",
  "terms.s5.p2": "Er wordt geen aansprakelijkheid aanvaard voor schade als gevolg van onjuist gebruik, opslag in ongeventileerde ruimtes, of het niet opvolgen van de veiligheidsinstructies door de klant of derden.",
  "terms.s6.title": "Artikel 6 | Betaling",
  "terms.s6.p1": "Betaling dient te geschieden binnen de op de factuur vermelde betalingstermijn. Bij zakelijke klanten met een goedgekeurde kredietlimiet bedraagt de standaard betalingstermijn 14 dagen, tenzij anders overeengekomen.",
  "terms.s6.p2": "Bij overschrijding van de betalingstermijn is de klant van rechtswege in verzuim en kan de wettelijke handelsrente in rekening worden gebracht, alsmede buitengerechtelijke incassokosten.",
  "terms.s7.title": "Artikel 7 | Aansprakelijkheid",
  "terms.s7.p1": "De aansprakelijkheid is beperkt tot het bedrag dat in het desbetreffende geval door de aansprakelijkheidsverzekering wordt uitgekeerd, vermeerderd met het eigen risico. Indien geen uitkering plaatsvindt, is de aansprakelijkheid beperkt tot het factuurbedrag van de betreffende bestelling.",
  "terms.s7.p2": "Er wordt nimmer aansprakelijkheid aanvaard voor indirecte schade, waaronder gevolgschade, gederfde winst, gemiste besparingen of schade door bedrijfsstagnatie.",
  "terms.s8.title": "Artikel 8 | Overmacht",
  "terms.s8.p1": "In geval van overmacht, waaronder maar niet beperkt tot stakingen, natuurrampen, pandemieën, overheidsmaatregelen, transportproblemen of tekorten aan grondstoffen, kan de levering worden opgeschort of de overeenkomst worden ontbonden zonder schadeplichtigheid.",
  "terms.s9.title": "Artikel 9 | Intellectueel eigendom",
  "terms.s9.p1": "Alle intellectuele eigendomsrechten op het bestelportaal, de website, merkidentiteit en documentatie zijn voorbehouden. Niets uit deze materialen mag worden verveelvoudigd zonder voorafgaande schriftelijke toestemming.",
  "terms.s9.p2": "Het gebruik van het klantenportaal verleent de klant een beperkt, niet-exclusief en herroepelijk gebruiksrecht voor de duur van de overeenkomst.",
  "terms.s10.title": "Artikel 10 | Toepasselijk recht en geschillen",
  "terms.s10.p1": "Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement Amsterdam.",

  // Privacy Policy
  "privacy.title": "Privacybeleid",
  "privacy.lastUpdated": "Laatst bijgewerkt",
  "privacy.s1.title": "1. Wie zijn wij?",
  "privacy.s1.p1": "Dutch DryIce B.V. is verantwoordelijk voor de verwerking van persoonsgegevens zoals beschreven in dit privacybeleid. Wij zijn gevestigd te Weesp, Nederland.",
  "privacy.s1.p2": "Voor vragen over dit privacybeleid kunt u contact opnemen via info@dutchdryice.com.",
  "privacy.s2.title": "2. Welke gegevens verzamelen wij?",
  "privacy.s2.p1": "Wij verzamelen en verwerken de volgende persoonsgegevens:",
  "privacy.s2.l1": "Naam, e-mailadres, telefoonnummer en bedrijfsgegevens (bij het aanmaken van een account of plaatsen van een bestelling)",
  "privacy.s2.l2": "Aflever- en factuuradresgegevens",
  "privacy.s2.l3": "Bestelhistorie, factuurgegevens en betalingsinformatie",
  "privacy.s2.l4": "Communicatiegegevens (berichten via het portaal, e-mails, supporttickets)",
  "privacy.s2.l5": "Technische gegevens (IP-adres, browsertype, apparaatinformatie) bij gebruik van onze website en portaal",
  "privacy.s3.title": "3. Waarvoor gebruiken wij uw gegevens?",
  "privacy.s3.p1": "Wij verwerken uw persoonsgegevens voor de volgende doeleinden:",
  "privacy.s3.l1": "Het uitvoeren van de overeenkomst: verwerken van bestellingen, levering, facturatie en klantenservice",
  "privacy.s3.l2": "Accountbeheer: aanmaken en onderhouden van uw klantenportaal-account",
  "privacy.s3.l3": "Communicatie: orderbevestigingen, statusupdates, factuurherinneringen en servicemeldingen",
  "privacy.s3.l4": "Wettelijke verplichtingen: fiscale administratie en wettelijke bewaarplichten",
  "privacy.s4.title": "4. Rechtsgronden voor verwerking",
  "privacy.s4.p1": "Wij verwerken uw persoonsgegevens op basis van: (a) uitvoering van de overeenkomst, (b) wettelijke verplichtingen, (c) gerechtvaardigd belang (zoals het verbeteren van onze dienstverlening en het voorkomen van fraude).",
  "privacy.s4.p2": "Voor het versturen van commerciële communicatie vragen wij vooraf uw toestemming, die u te allen tijde kunt intrekken.",
  "privacy.s5.title": "5. Delen met derden",
  "privacy.s5.p1": "Wij delen uw persoonsgegevens uitsluitend met derden wanneer dit noodzakelijk is voor de uitvoering van de overeenkomst, zoals transportpartners voor de bezorging van uw bestelling en betalingsverwerkers.",
  "privacy.s5.p2": "Wij verkopen uw persoonsgegevens nimmer aan derden. Met alle verwerkers sluiten wij verwerkersovereenkomsten om de beveiliging van uw gegevens te waarborgen.",
  "privacy.s6.title": "6. Uw rechten",
  "privacy.s6.p1": "Op grond van de AVG (GDPR) heeft u de volgende rechten:",
  "privacy.s6.l1": "Recht op inzage in uw persoonsgegevens",
  "privacy.s6.l2": "Recht op rectificatie van onjuiste gegevens",
  "privacy.s6.l3": "Recht op verwijdering van uw gegevens ('recht op vergetelheid')",
  "privacy.s6.l4": "Recht op beperking van de verwerking",
  "privacy.s6.l5": "Recht op overdraagbaarheid van uw gegevens",
  "privacy.s7.title": "7. Beveiliging",
  "privacy.s7.p1": "Wij nemen passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen ongeoorloofde toegang, verlies of misbruik. Dit omvat versleutelde verbindingen (SSL/TLS), toegangscontroles en regelmatige beveiligingsaudits.",
  "privacy.s7.p2": "Uw wachtwoord wordt versleuteld opgeslagen en is voor niemand, inclusief onze medewerkers, inzichtelijk.",
  "privacy.s8.title": "8. Bewaartermijnen",
  "privacy.s8.p1": "Wij bewaren uw persoonsgegevens niet langer dan noodzakelijk voor de doeleinden waarvoor zij zijn verzameld. Fiscale gegevens worden conform de wettelijke bewaarplicht 7 jaar bewaard. Accountgegevens worden verwijderd binnen 12 maanden na beëindiging van de klantrelatie, tenzij wettelijke verplichtingen anders vereisen.",
  "privacy.s9.title": "9. Cookies",
  "privacy.s9.p1": "Onze website en ons portaal maken gebruik van functionele cookies die noodzakelijk zijn voor het correct functioneren van de dienst, zoals het onthouden van uw inlogsessie.",
  "privacy.s9.p2": "Wij gebruiken geen tracking cookies of cookies van derden voor marketingdoeleinden zonder uw uitdrukkelijke toestemming.",

  // About
  "about.title": "Over ons",
  "about.subtitle": "Leer meer over Dutch DryIce en ons team.",
  "about.badge": "Over Dutch DryIce",
  "about.heroTitle": "Jouw partner in",
  "about.heroHighlight": "droogijs oplossingen",
  "about.heroSubtitle": "Met NEN-gecertificeerd droogijs en een sterke focus op kwaliteit en ontzorging van begin tot eind. Jouw tevredenheid staat bij ons voorop: je kunt altijd op ons rekenen, we zijn altijd bereikbaar en bieden een hoog serviceniveau.",
  "about.missionTitle": "Wie zijn wij?",
  "about.missionP1": "Dutch DryIce is een ISO-gecertificeerd productiebedrijf (ISO 9001, 14001 & 22000) dat dagelijks vers FSSC ISO 22000 gecertificeerd biodroogijs produceert uit bio CO₂. Wij zijn geen tussenhandel maar producent, en leveren door heel Nederland.",
  "about.missionP2": "Voor 12:00 uur besteld? Dan is je droogijs morgen geleverd. Onverwachte situaties? Wij zijn 24/7 beschikbaar voor spoedorders. Met onze Ecovadis Bronze score tonen wij ons commitment aan duurzaamheid en maatschappelijk verantwoord ondernemen.",
  "about.contactBtn": "Neem contact op",
  "about.valuesTitle": "Onze kernwaarden",
  "about.valuesSubtitle": "Waar we voor staan en waarom klanten ons vertrouwen.",
  "about.val1Title": "ISO Gecertificeerd",
  "about.val1Desc": "ISO 9001, 14001 & 22000 gecertificeerd productiebedrijf met FSSC ISO 22000 droogijs.",
  "about.val2Title": "Snelle levering",
  "about.val2Desc": "Voor 12:00 besteld = morgen geleverd door heel Nederland.",
  "about.val3Title": "Biodroogijs",
  "about.val3Desc": "Vers geproduceerd biodroogijs uit bio CO₂ voor de beste resultaten.",
  "about.val4Title": "Ecovadis Bronze",
  "about.val4Desc": "Ecovadis Bronze gecertificeerd. Wij zetten ons in voor duurzaam en verantwoord ondernemen.",
  "about.offerTitle": "Wat kunnen wij voor je doen?",
  "about.offer1Title": "Reguliere leveringen",
  "about.offer1Desc": "Voor al je geplande en terugkerende bestellingen ben je bij ons aan het juiste adres.",
  "about.offer2Title": "Spoedleveringen",
  "about.offer2Desc": "Dringend droogijs nodig? Geen zorgen! Bel ons op elk moment en wij regelen je bestelling direct.",
  "about.offer3Title": "Advies en ondersteuning",
  "about.offer3Desc": "Onze experts staan klaar om je te adviseren over de beste toepassingen van droogijs.",
  "about.ctaTitle": "Klaar om te bestellen?",
  "about.ctaText": "Bestel direct droogijs via ons platform of neem contact met ons op voor advies op maat.",
  "about.ctaOrder": "Nu bestellen",
  "about.ctaContact": "Contact",

  // Contact
  "contact.title": "Contact",
  "contact.subtitle": "Neem contact met ons op.",
  "contact.name": "Naam",
  "contact.email": "E-mailadres",
  "contact.message": "Bericht",
  "contact.send": "Versturen",
  "contact.sent": "Bericht verstuurd",
  "contact.badge": "Contact",
  "contact.heroTitle": "Neem",
  "contact.heroHighlight": "contact met ons op",
  "contact.heroSubtitle": "Heb je een vraag, wil je een bestelling plaatsen of advies over droogijs? Wij zijn 24/7 bereikbaar en helpen je graag!",
  "contact.infoTitle": "Contactgegevens",
  "contact.phoneDesc": "24/7 bereikbaar, ook voor spoedorders",
  "contact.emailDesc": "Reactie binnen 24 uur",
  "contact.location": "Nederland",
  "contact.availability": "24/7 bereikbaar",
  "contact.availabilityDesc": "Voor reguliere én spoedorders",
  "contact.urgentTitle": "Spoedbestelling?",
  "contact.urgentDesc": "Mail ons direct voor spoedleveringen. Wij staan 24/7 klaar.",
  "contact.callNow": "Mail ons",
  "contact.formTitle": "Stuur ons een bericht",
  "contact.formSubtitle": "Vul het formulier in en wij nemen zo snel mogelijk contact met je op.",
  "contact.labelName": "Naam",
  "contact.placeholderName": "Je naam",
  "contact.labelCompany": "Bedrijfsnaam",
  "contact.placeholderCompany": "Je bedrijf",
  "contact.labelEmail": "E-mailadres",
  "contact.placeholderEmail": "naam@bedrijf.nl",
  "contact.labelPhone": "Telefoonnummer",
  "contact.labelSubject": "Onderwerp",
  "contact.placeholderSubject": "Waar gaat je vraag over?",
  "contact.labelMessage": "Bericht",
  "contact.placeholderMessage": "Vertel ons meer over je vraag of bestelling...",
  "contact.sending": "Verzenden...",
  "contact.sendBtn": "Bericht verzenden",
  "contact.successTitle": "Bericht verzonden",
  "contact.successDesc": "Wij nemen zo snel mogelijk contact met je op.",
  "contact.errorTitle": "Fout",
  "contact.errorDesc": "Er ging iets mis. Probeer het opnieuw.",
  "contact.ctaTitle": "Liever direct bestellen?",
  "contact.ctaText": "Bestel droogijs via ons platform, geen account nodig.",
  "contact.ctaOrder": "Nu bestellen",

  // FAQ
  "faq.title": "Veelgestelde vragen",
  "faq.subtitle": "Antwoorden op de meest gestelde vragen.",
  "faq.badge": "Veelgestelde vragen",
  "faq.heroTitle": "Alles over",
  "faq.heroHighlight": "droogijs",
  "faq.heroSubtitle": "Op deze pagina vind je antwoorden op de meest gestelde vragen. Staat jouw vraag er niet tussen? Neem dan contact met ons op.",
  "faq.ctaTitle": "Vraag niet beantwoord?",
  "faq.ctaText": "Neem contact met ons op, wij helpen je graag verder.",
  "faq.ctaContact": "Contact opnemen",
  "faq.ctaOrder": "Nu bestellen",
  "faq.cat1": "Algemene vragen",
  "faq.q1": "Wat is droogijs?",
  "faq.a1": "Droogijs is de vaste vorm van koolstofdioxide (CO₂). Het heeft de ongewone eigenschap dat het sublimeert, het gaat van vaste vorm naar gas over zonder een vloeibare tussenfase. Hierop is de naam droogijs gebaseerd: het laat namelijk geen vocht achter. Het product heeft een constante temperatuur van -79°C, ongeacht de hoeveelheid.",
  "faq.q2": "Wat is de temperatuur van droogijs?",
  "faq.a2": "De temperatuur van droogijs is -79 graden Celsius. Flink kouder dan normaal ijs (zo'n 3 keer de koelcapaciteit in vergelijking met waterijs). Het lijkt op echt ijs, maar in werkelijkheid is het bevroren CO₂.",
  "faq.q3": "Is droogijs veilig?",
  "faq.a3": "Als je droogijs gebruikt zoals het bedoeld is, is het veilig. Gebruik handschoenen, sla het op in geventileerde ruimtes, doe het nooit in een luchtdichte verpakking en houd het uit de buurt van kinderen.",
  "faq.q4": "Leveren jullie ook aan particulieren?",
  "faq.a4": "Ja, wij leveren ook aan particulieren.",
  "faq.q5": "Mag ik droogijs retourneren?",
  "faq.a5": "Helaas is retourneren niet mogelijk wanneer je bestelling met droogijs is verzonden. Droogijs verdampt (sublimeert) snel bij kamertemperatuur.",
  "faq.cat2": "Hoeveelheid en bewaren",
  "faq.q6": "Hoe lang gaat droogijs mee?",
  "faq.a6": "Dat ligt aan de omstandigheden. In onze EPS-dozen blijft het droogijs 3 tot 5 dagen goed. Bij kamertemperatuur verdampt er 10-15% per dag.",
  "faq.q7": "Hoeveel droogijs heb ik nodig?",
  "faq.a7": "Voor kleine presentaties is onze 10 kg verpakking ideaal. Voor grootse effecten raden wij de 25 kg verpakking aan.",
  "faq.q8": "Wat als ik slechts een heel kleine hoeveelheid nodig heb?",
  "faq.a8": "Voor verzending hanteren wij een minimale hoeveelheid van 6 kilogram.",
  "faq.q9": "Hoe bewaar ik mijn droogijs?",
  "faq.a9": "Bewaar droogijs op een geïsoleerde plek, de meegeleverde doos is hier uitermate geschikt voor. Sla droogijs nooit op in een luchtdichte houder.",
  "faq.cat3": "Droogijs mist & rook",
  "faq.q10": "Wat is droogijs mist / rook?",
  "faq.a10": "Als je droogijs toevoegt aan warm water ontstaat er direct een dichte witte mist. Droogijsrook heeft geen geur, bevat geen chemicaliën en laat geen resten achter.",
  "faq.q11": "Hoe maak ik droogijs mist?",
  "faq.a11": "Voeg droogijs toe aan een bak met heet water (rond 50°C) en de mist ontstaat onmiddellijk.",
  "faq.cat4": "Droogijs zakelijk",
  "faq.q12": "Zijn er kosten verbonden aan het gebruik van containers?",
  "faq.a12": "Nee, u betaalt alleen voor het droogijs en het transport.",
  "faq.q13": "Kan ik een herhaalorder plaatsen?",
  "faq.a13": "Ja, dat is mogelijk. Kies bij het bestellen de abonnementsoptie.",
  "faq.q14": "Hoeveel droogijs kan ik per container bestellen?",
  "faq.a14": "Wij bieden containers aan vanaf 150 kg tot 440 kg.",
  "faq.q15": "Is het mogelijk om droogijs schijven te bestellen?",
  "faq.a15": "Ja, neem contact op met onze klantenservice voor een offerte op maat.",
  "faq.q17": "Wat is het verschil tussen droogijs pellets en blokken?",
  "faq.a17": "Droogijs pellets zijn kleine korrels (3-10 mm) die ideaal zijn voor koeling van kleinere zendingen en droogijsstralen. Blokken zijn grotere stukken die langzamer sublimeren en daardoor langer koud houden – geschikt voor langdurig transport en grotere volumes.",
  "faq.q18": "Kan ik droogijs eten of in drankjes gebruiken?",
  "faq.a18": "Droogijs mag nooit direct geconsumeerd worden. Het kan wel gebruikt worden om drankjes te koelen of spectaculaire rookeffecten te creëren in cocktails, maar het droogijs zelf mag niet ingeslikt worden vanwege het risico op bevriezing.",
  "faq.q19": "Is droogijs gevaarlijk?",
  "faq.a19": "Bij correct gebruik is droogijs veilig. Draag altijd isolerende handschoenen, werk in een goed geventileerde ruimte en bewaar het nooit in een luchtdichte container. Direct huidcontact kan bevriezing veroorzaken.",
  "faq.q20": "Wat gebeurt er als droogijs smelt?",
  "faq.a20": "Droogijs smelt niet zoals gewoon ijs. Het sublimeert: het gaat rechtstreeks over van vaste stof naar gas (CO₂). Er blijft dus geen water of residu achter.",
  "faq.cat5": "Bestellen & levering",
  "faq.q21": "Hoe bestel ik droogijs?",
  "faq.a21": "U kunt eenvoudig online bestellen via onze website. Kies de gewenste hoeveelheid, verpakkingstype en leveringsdag. Bestellingen voor 12:00 uur worden de volgende werkdag geleverd.",
  "faq.q22": "Wat zijn de levertijden?",
  "faq.a22": "Wij leveren in heel Nederland, doorgaans de volgende werkdag. Voor spoedbestellingen kunt u contact opnemen – wij zijn 24/7 bereikbaar voor urgente leveringen.",
  "faq.q23": "Wat zijn de verzendkosten?",
  "faq.a23": "De verzendkosten zijn afhankelijk van het gewicht en de bestemming. Bij het afrekenen ziet u direct de exacte kosten. Voor abonnementsklanten bieden wij aantrekkelijke verzendtarieven.",
  "faq.q24": "Kan ik droogijs laten bezorgen op zaterdag?",
  "faq.a24": "Standaard leveren wij op werkdagen. Voor zaterdaglevering kunt u contact opnemen met onze klantenservice om de mogelijkheden te bespreken.",
  "faq.q25": "Waar leveren jullie?",
  "faq.a25": "Wij leveren door heel Nederland. Bestellingen geplaatst voor 12:00 worden de volgende werkdag geleverd.",
  "faq.cat6": "Droogijsstralen",
  "faq.q26": "Hoe werkt droogijsstralen?",
  "faq.a26": "Door middel van perslucht worden droogijskorrels tegen het oppervlak gestraald. Droogijs is een milieuvriendelijke reinigingsmethode zonder restafval, omdat het droogijs direct sublimeert bij impact.",
  "faq.q27": "Welke oppervlakken kan ik reinigen met droogijsstralen?",
  "faq.a27": "Droogijsstralen is geschikt voor vrijwel alle oppervlakken: metaal, beton, hout, kunststof en elektrische componenten. Het is niet-abrasief en beschadigt het onderliggende materiaal niet.",
  "faq.q28": "Is droogijsstralen milieuvriendelijk?",
  "faq.a28": "Ja, droogijsstralen is zeer milieuvriendelijk. Er worden geen chemicaliën gebruikt, er is geen secundair afval en het droogijs verdampt volledig. Het is goedgekeurd voor gebruik in de voedingsindustrie.",
  "faq.cat7": "Toepassingen",
  "faq.q29": "Waarvoor wordt droogijs gebruikt in de horeca?",
  "faq.a29": "In de horeca wordt droogijs gebruikt voor het koel houden van voedsel tijdens catering en transport, het creëren van rookeffecten bij cocktails en presentaties, en het snel invriezen van ingrediënten.",
  "faq.q30": "Hoe wordt droogijs gebruikt bij medisch transport?",
  "faq.a30": "Droogijs houdt medische zendingen, vaccins en biologische monsters op de vereiste lage temperatuur tijdens transport. Onze NEN-gecertificeerde verpakkingen garanderen een constante temperatuur gedurende het gehele transport.",
  "faq.q31": "Kan ik droogijs gebruiken voor voedselbezorging?",
  "faq.a31": "Absoluut. Droogijs is ideaal voor het koel houden van bederfelijke waren tijdens bezorging. Het houdt producten tot -79°C en laat geen water achter, waardoor uw producten droog en vers aankomen.",
  "faq.q32": "Is droogijs geschikt voor evenementen?",
  "faq.a32": "Ja, droogijs wordt veel gebruikt bij evenementen voor spectaculaire rookeffecten, het koelen van drankjes en het creëren van sfeer. Wij adviseren u graag over de juiste hoeveelheid voor uw evenement.",


  // Admin Navigation
  "admin.dashboard": "Dashboard",
  "admin.helpdesk": "Helpdesk",
  "admin.orders": "Bestellingen",
  "admin.shipments": "Verzendingen",
  "admin.invoices": "Facturen",
  "admin.production": "Productie",
  "admin.customers": "Klanten",
  "admin.users": "Gebruikers",
  "admin.costCalculation": "Kostprijs",
  "admin.costCalc": "Kostprijs",
  "admin.serviceMonitor": "Service Monitor",
  "admin.financial": "Financieel",
  "admin.reporting": "Rapportage",
  "admin.auditLog": "Audit Log",
  "admin.settings": "Instellingen",
  "admin.translations": "Vertalingen",
  "admin.backToPortal": "Terug naar portaal",
  "admin.overview": "Overzicht",
  "admin.management": "Beheer",
  "admin.customerPortal": "Klantenportaal",
  "admin.language": "Taal",
  "admin.theme": "Thema",
  "admin.logout": "Uitloggen",
  "admin.noCompany": "Geen bedrijf",
  "admin.user": "Gebruiker",
  "admin.impersonationActive": "Impersonatie actief",
  "admin.viewingAs": "Je bekijkt het platform als",
  "admin.backToOwnAccount": "Terug naar eigen account",

  // Info ticker
  "ticker.sublimation": "Sublimatieverlies: reken ~10% extra droogijs mee voor transport.",
  "ticker.temperature": "Droogijs sublimeert bij -78,5°C | ideaal voor de koudeketen.",
  "ticker.eps": "EPS-dozen houden de kou vast tot 72 uur, afhankelijk van hoeveelheid.",
  "ticker.safety": "Gebruik droogijs altijd in goed geventileerde ruimtes (CO₂-risico).",

  // Onboarding (public)
  "onboarding.welcomePublic": "Welkom bij Dutch DryIce",
  "onboarding.letsStart": "Laten we beginnen",
  "onboarding.skip": "Overslaan",
  "onboarding.completePublic": "Voltooien",

  // Review
  "review.title": "Beoordeling",
  "review.score": "Score",
  "review.comment": "Opmerking",
  "review.submit": "Beoordeling versturen",
  "review.submitted": "Bedankt voor je beoordeling!",

  // Language
  "language.nl": "Nederlands",
  "language.en": "English",
  "language.switch": "Taal",

  // Solution layout shared
  "solution.orderNow": "Bestellen",
  "solution.requestAdvice": "Advies aanvragen",
  "solution.orderDirect": "Direct bestellen",
  "solution.howItWorks": "Hoe werkt het?",
  "solution.processSubtitle": "In een paar eenvoudige stappen geregeld",
  "solution.advantages": "Voordelen",
  "solution.advantagesSubtitle": "Waarom bedrijven kiezen voor Dutch DryIce | NEN-gecertificeerd",
  "solution.useCases": "Toepassingen",
  "solution.useCasesSubtitle": "Ontdek hoe onze klanten droogijs inzetten",
  "solution.faq": "Veelgestelde vragen",
  "solution.orderNowCta": "Nu bestellen",
  "solution.contactUs": "Contact opnemen",

  // Horeca & Catering
  "horeca.badge": "Horeca & Catering",
  "horeca.title": "Droogijs voor",
  "horeca.titleHighlight": "horeca & catering",
  "horeca.subtitle": "Vers geproduceerd, FSSC ISO 22000 gecertificeerd biodroogijs voor koeling, presentatie en spectaculaire rookeffecten in de horeca.",
  "horeca.stat1": "Minimale bestelling",
  "horeca.stat2": "Biodroogijs",
  "horeca.stat3": "ISO 22000 gecertificeerd",
  "horeca.stat4": "Spoedservice",
  "horeca.introTitle": "Droogijs in de horeca",
  "horeca.intro1": "Steeds meer restaurants, bars, cateraars en evenementenlocaties gebruiken droogijs voor spectaculaire rookeffecten, het koelen van ingrediënten en het serveren van desserts en cocktails. Van Michelin-restaurants tot foodtrucks, droogijs is niet meer weg te denken uit de moderne horeca.",
  "horeca.intro2": "Bij Dutch DryIce bestel je eenvoudig de hoeveelheid droogijs die je nodig hebt, wanneer je het nodig hebt. Eenmalig of als herhaalbestelling, jij bepaalt. Ons NEN-gecertificeerd droogijs wordt altijd vers geproduceerd op de dag van levering.",
  "horeca.intro3": "Of je nu wekelijks een vaste hoeveelheid nodig hebt of alleen voor een speciaal diner: wij leveren flexibel en snel, door heel Nederland. Geen verplichtingen, geen lange contracten.",
  "horeca.intro4": "Ons team denkt graag mee over de juiste vorm en hoeveelheid voor jouw toepassing. Pellets voor cocktails, schijven voor koeling van ingrediënten of blokken voor langdurige bewaring, wij adviseren je kosteloos.",
  "horeca.processTitle": "Zo bestel je droogijs voor je zaak",
  "horeca.step1Title": "Kies je product",
  "horeca.step1Desc": "Selecteer de gewenste hoeveelheid droogijs (vanaf 6 kg), de vorm (pellets, schijven of blokken) en het aantal dozen of containers.",
  "horeca.step2Title": "Kies je levermoment",
  "horeca.step2Desc": "Selecteer de gewenste leverdatum en -tijd. Wij leveren van dinsdag t/m vrijdag.",
  "horeca.step3Title": "Wij produceren en leveren",
  "horeca.step3Desc": "Je droogijs wordt vers geproduceerd op de dag van levering en bij je bezorgd.",
  "horeca.step4Title": "Optioneel: herhaalbestelling",
  "horeca.step4Desc": "Tevreden? Zet een herhaalbestelling op en ontvang automatisch droogijs op je vaste momenten, met staffelkorting.",
  "horeca.feat1Title": "NEN-gecertificeerd",
  "horeca.feat1Desc": "Ons droogijs voldoet aan de strenge NEN-normen voor kwaliteit en voedselveiligheid.",
  "horeca.feat2Title": "Vers geproduceerd",
  "horeca.feat2Desc": "Altijd vers droogijs voor de beste rookeffecten en langste houdbaarheid.",
  "horeca.feat3Title": "Flexibel bestellen",
  "horeca.feat3Desc": "Bestel wanneer je wilt, eenmalig of als herhaalbestelling. Geen contractverplichtingen.",
  "horeca.feat4Title": "Staffelkorting",
  "horeca.feat4Desc": "Hoe meer en vaker je bestelt, hoe voordeliger het wordt. Tot 15% korting bij herhaalbestellingen.",
  "horeca.feat5Title": "Klein of groot volume",
  "horeca.feat5Desc": "Vanaf 6 kg per levering, ook geschikt voor grote locaties met honderden kg per week.",
  "horeca.feat6Title": "24/7 spoedservice",
  "horeca.feat6Desc": "Extra nodig voor een onverwacht evenement? Bel ons direct en wij leveren binnen enkele uren.",
  "horeca.feat7Title": "Persoonlijk advies",
  "horeca.feat7Desc": "Onze horeca-specialisten adviseren je over de juiste hoeveelheid en vorm voor jouw toepassing.",
  "horeca.feat8Title": "Milieuvriendelijk",
  "horeca.feat8Desc": "Droogijs sublimeert volledig, geen afvalwater, geen chemicaliën, geen restproducten.",
  "horeca.feat9Title": "Herhaalbestelling mogelijk",
  "horeca.feat9Desc": "Stel een terugkerend schema in en ontvang automatisch op je vaste dag. Wijzigen of pauzeren kan altijd.",
  "horeca.uc1Title": "Cocktailbars & lounges",
  "horeca.uc1Desc": "Spectaculaire rookeffecten in signature cocktails, mocktails en dessertpresentaties die je gasten niet snel vergeten.",
  "horeca.uc2Title": "Restaurants & fine dining",
  "horeca.uc2Desc": "Koeling van ingrediënten tijdens mise-en-place, dramatische presentatie van gerechten en flash-freezing van creatieve bereidingen.",
  "horeca.uc3Title": "Catering & events",
  "horeca.uc3Desc": "Betrouwbare koeling tijdens transport van maaltijden naar locatie, plus sfeervolle mist- en rookeffecten op het evenement zelf.",
  "horeca.uc4Title": "IJssalons & patisserie",
  "horeca.uc4Desc": "Droogijs voor het snel invriezen van ijs en sorbets, en voor het op temperatuur houden van vitrines zonder stroom.",
  "horeca.uc5Title": "Foodtrucks",
  "horeca.uc5Desc": "Compacte koeloplossing zonder zware apparatuur. Ideaal voor festivals en markten waar stroomaansluiting beperkt is.",
  "horeca.uc6Title": "Hotels & resorts",
  "horeca.uc6Desc": "Dagelijkse bevoorrading voor roomservice, wellness-toepassingen en gastronomische ervaringen.",
  "horeca.faq1Q": "Moet ik een abonnement afsluiten?",
  "horeca.faq1A": "Nee, je kunt gewoon losse bestellingen plaatsen. Een herhaalbestelling is optioneel en biedt extra voordelen zoals staffelkorting en automatische levering.",
  "horeca.faq2Q": "Wat is de minimale bestelhoeveelheid?",
  "horeca.faq2A": "Je kunt bestellen vanaf 6 kg droogijs per levering. Voor de meeste horecazaken adviseren wij minimaal 10 kg voor optimale resultaten.",
  "horeca.faq3Q": "Hoe vers is het droogijs bij levering?",
  "horeca.faq3A": "Ons droogijs wordt altijd op de dag van levering geproduceerd. Hierdoor ontvang je het verst mogelijke product met minimale sublimatie.",
  "horeca.faq4Q": "Welke vorm droogijs is het beste voor cocktails?",
  "horeca.faq4A": "Voor cocktails en drankeffecten adviseren wij pellets (3 mm). Deze sublimeren snel en geven het mooiste visuele effect. Voor koeling van ingrediënten zijn schijven of blokken beter geschikt.",
  "horeca.faq5Q": "Is droogijs veilig voor gebruik in de horeca?",
  "horeca.faq5A": "Ja, mits correct gebruikt. Droogijs mag niet direct geconsumeerd worden, maar is veilig voor indirect contact met voedsel en dranken. Wij leveren altijd veiligheidsinstructies mee.",
  "horeca.faq6Q": "Hoe hoog is de staffelkorting?",
  "horeca.faq6A": "De korting is afhankelijk van je bestelvolume en frequentie. Bij herhaalbestellingen kun je tot 15% besparen ten opzichte van losse bestellingen.",
  "horeca.ctaTitle": "Droogijs bestellen voor je horecazaak",
  "horeca.ctaText": "Bestel eenvoudig online, wij produceren vers en leveren op het moment dat jij het nodig hebt.",

  // Voedselindustrie
  "food.badge": "Voedselindustrie",
  "food.title": "Droogijs voor de",
  "food.titleHighlight": "voedselindustrie",
  "food.subtitle": "FSSC ISO 22000 gecertificeerd biodroogijs voor food processing, invriezen, voedselveiligheid en koeling van versproducten.",
  "food.stat1": "Koeling gegarandeerd",
  "food.stat2": "Compliant",
  "food.stat3": "ISO 22000 gecertificeerd",
  "food.stat4": "Dekking",
  "food.introTitle": "NEN-gecertificeerd droogijs voor de voedselindustrie",
  "food.intro1": "De voedselindustrie stelt hoge eisen aan koeling, voedselveiligheid en traceerbaarheid. Droogijs is de ideale oplossing voor flash-freezing, het op temperatuur houden van versproducten en koeling tijdens productie, opslag en distributie.",
  "food.intro2": "Al ons droogijs is NEN-gecertificeerd en voldoet aan de strenge normen voor food-grade toepassingen. Met EPS-dozen of geïsoleerde containers garanderen wij dat uw producten in perfecte staat blijven, tot 72 uur lang.",
  "food.intro3": "Wij leveren aan slagerijen, visverwerkers, zuivelfabrieken, bakkerijen, maaltijdproducenten en distributiecentra door heel Nederland. Van dagelijkse bulkleveringen tot kleinere bestellingen.",
  "food.intro4": "Ons platform biedt real-time inzicht in je bestellingen en leveringen. Stel eenvoudig een herhaalbestelling in en automatiseer je droogijsvoorziening volledig.",
  "food.processTitle": "Droogijs in uw productieketen",
  "food.step1Title": "Bestel of automatiseer",
  "food.step1Desc": "Plaats handmatig een bestelling via ons platform of stel een herhaalbestelling in voor automatische levering.",
  "food.step2Title": "Wij produceren NEN-gecertificeerd",
  "food.step2Desc": "Vers droogijs wordt geproduceerd conform NEN-normen en in EPS-dozen of containers verpakt.",
  "food.step3Title": "Levering op uw locatie",
  "food.step3Desc": "Wij leveren aan uw productielocatie, distributiecentrum of fulfilmentlocatie, dinsdag t/m vrijdag.",
  "food.step4Title": "Inzet in uw proces",
  "food.step4Desc": "Gebruik het droogijs voor flash-freezing, koeling tijdens transport of het op temperatuur houden van uw producten.",
  "food.feat1Title": "NEN-gecertificeerd",
  "food.feat1Desc": "Ons droogijs voldoet aan de strenge NEN-normen voor food-grade toepassingen en voedselveiligheid.",
  "food.feat2Title": "Tot 72 uur koeling",
  "food.feat2Desc": "EPS-dozen houden producten tot 3 dagen op temperatuur, zelfs bij hoge buitentemperaturen.",
  "food.feat3Title": "HACCP-compliant",
  "food.feat3Desc": "Onze processen en producten voldoen aan HACCP-normen voor de voedselindustrie.",
  "food.feat4Title": "Schaalbaar",
  "food.feat4Desc": "Van 10 kg tot tientallen tonnen per dag, wij groeien mee met uw productie.",
  "food.feat5Title": "Flash-freezing",
  "food.feat5Desc": "Gebruik droogijs voor het razendsnel invriezen van versproducten met behoud van kwaliteit.",
  "food.feat6Title": "Pellets, schijven of blokken",
  "food.feat6Desc": "Kies de vorm die het beste past bij uw productieproces en producttype.",
  "food.feat7Title": "Duurzaam",
  "food.feat7Desc": "Droogijs sublimeert zonder restafval. Geen water, geen chemicaliën, goed voor uw CO₂-footprint.",
  "food.feat8Title": "Temperatuurmonitoring",
  "food.feat8Desc": "Optionele temperatuursensoren geven zekerheid over de koelketen en compliance-documentatie.",
  "food.feat9Title": "Same-day productie",
  "food.feat9Desc": "Droogijs wordt op de dag van levering geproduceerd voor maximale houdbaarheid en koelcapaciteit.",
  "food.uc1Title": "Vlees- en visverwerking",
  "food.uc1Desc": "Koeling en flash-freezing tijdens verwerking en opslag. Voldoe aan HACCP-normen gedurende de hele keten.",
  "food.uc2Title": "Zuivelindustrie",
  "food.uc2Desc": "Temperatuurbeheersing van melkproducten, kaas en boter tijdens productie en opslag.",
  "food.uc3Title": "Bakkerijen & patisserie",
  "food.uc3Desc": "Koeling van deeg, room en smeltgevoelige producten. Flash-freezing voor langere houdbaarheid.",
  "food.uc4Title": "Maaltijdproducenten",
  "food.uc4Desc": "Koeling van kant-en-klare maaltijden en ingrediënten tijdens assemblage en opslag.",
  "food.uc5Title": "Groente- en fruitverwerking",
  "food.uc5Desc": "Snel invriezen van vers gesneden groente en fruit voor maximaal behoud van vitaminen en textuur.",
  "food.uc6Title": "Distributiecentra",
  "food.uc6Desc": "Droogijs als buffer bij koeluitval of voor het op temperatuur houden van temperatuurgevoelige producten.",
  "food.faq1Q": "Is jullie droogijs geschikt voor direct contact met voedsel?",
  "food.faq1A": "Ja, ons droogijs is NEN-gecertificeerd en food-grade. Het is veilig voor direct en indirect contact met voedselproducten.",
  "food.faq2Q": "Hoeveel droogijs heb ik nodig voor flash-freezing?",
  "food.faq2A": "Dit hangt af van het productvolume en de gewenste bevriezingssnelheid. Als vuistregel: 1-2 kg droogijs per kg product. Wij adviseren u graag.",
  "food.faq3Q": "Leveren jullie ook in containers?",
  "food.faq3A": "Ja, wij leveren in EPS-dozen (6-25 kg) en geïsoleerde containers (150-440 kg). Containergebruik is kosteloos.",
  "food.faq4Q": "Kan ik een herhaalbestelling instellen?",
  "food.faq4A": "Ja, via ons platform kunt u eenvoudig een herhaalbestelling instellen. U profiteert van staffelkorting en automatische levering.",
  "food.faq5Q": "Voldoen jullie aan HACCP-normen?",
  "food.faq5A": "Ja, onze processen en producten voldoen aan HACCP-normen. NEN-certificaten en productdocumentatie zijn beschikbaar op aanvraag.",
  "food.ctaTitle": "Droogijs bestellen voor uw voedselproductie",
  "food.ctaText": "NEN-gecertificeerd droogijs voor flash-freezing, koeling en voedselveiligheid in de voedselindustrie.",

  // Medisch & Farmaceutisch
  "pharma.badge": "Medisch & Farmaceutisch",
  "pharma.title": "Droogijs voor",
  "pharma.titleHighlight": "medische & farmaceutische toepassingen",
  "pharma.subtitle": "FSSC ISO 22000 gecertificeerd biodroogijs voor de koude keten van temperatuurgevoelige producten. Vers geproduceerd, snel geleverd.",
  "pharma.stat1": "Constante temperatuur",
  "pharma.stat2": "ISO 22000 gecertificeerd",
  "pharma.stat3": "Spoedproductie",
  "pharma.stat4": "Biodroogijs",
  "pharma.introTitle": "NEN-gecertificeerd droogijs voor de medische sector",
  "pharma.intro1": "Voor farmaceutische producten, laboratoriummonsters en biologisch materiaal is een ononderbroken koude keten essentieel. Droogijs biedt een constante temperatuur van -79°C en is daarmee onmisbaar in de medische en farmaceutische sector.",
  "pharma.intro2": "Al ons droogijs is NEN-gecertificeerd en voldoet aan de strengste kwaliteitsnormen voor medische en farmaceutische toepassingen. Wij produceren vers op de dag van levering en leveren in speciaal geïsoleerde EPS-verpakkingen of containers.",
  "pharma.intro3": "Dutch DryIce levert het droogijs en de juiste verpakkingen. Heeft u een logistieke partner nodig voor verder transport? Wij brengen u graag in contact met gespecialiseerde partijen die ervaring hebben met temperatuurgevoelige producten.",
  "pharma.intro4": "Onze partners voldoen aan GDP (Good Distribution Practice), GMP (Good Manufacturing Practice) en IATA-regelgeving. Wij adviseren u graag over de juiste hoeveelheid en verpakking.",
  "pharma.processTitle": "Hoe werkt het?",
  "pharma.step1Title": "Bestel uw droogijs",
  "pharma.step1Desc": "Bestel het gewenste droogijsvolume en de juiste verpakking via onze webshop of neem contact op voor advies op maat.",
  "pharma.step2Title": "Verpakking op maat",
  "pharma.step2Desc": "Wij leveren vers NEN-gecertificeerd droogijs in EPS-dozen of UN-gecertificeerde verpakkingen, klaar voor uw toepassing.",
  "pharma.step3Title": "Levering aan uw locatie",
  "pharma.step3Desc": "Wij leveren het droogijs bij u op locatie. Voor verder transport kunt u terecht bij onze gespecialiseerde logistieke partners.",
  "pharma.step4Title": "Advies en ondersteuning",
  "pharma.step4Desc": "Wij adviseren u over de juiste hoeveelheid droogijs, verpakking en documentatie. Neem contact op voor een vrijblijvend gesprek.",
  "pharma.feat1Title": "NEN-gecertificeerd",
  "pharma.feat1Desc": "Ons droogijs voldoet aan de strenge NEN-normen, essentieel voor medische en farmaceutische toepassingen.",
  "pharma.feat2Title": "Constante -79°C",
  "pharma.feat2Desc": "Droogijs houdt een stabiele temperatuur aan ongeacht de hoeveelheid. Geen stroom of koelmachine nodig.",
  "pharma.feat3Title": "Biodroogijs",
  "pharma.feat3Desc": "Ons droogijs wordt geproduceerd uit bio-CO₂, duurzaam en geschikt voor de meest veeleisende toepassingen.",
  "pharma.feat4Title": "Documentatie inbegrepen",
  "pharma.feat4Desc": "Bij elke bestelling leveren wij de benodigde documentatie zoals MSDS en kwaliteitscertificaten mee.",
  "pharma.feat5Title": "Betrouwbare koeling",
  "pharma.feat5Desc": "Ons droogijs garandeert langdurige koeling in EPS-dozen of containers, ideaal voor de koude keten.",
  "pharma.feat6Title": "FSSC ISO 22000",
  "pharma.feat6Desc": "Wij produceren volgens de strengste kwaliteitsnormen inclusief FSSC ISO 22000 certificering.",
  "pharma.feat7Title": "Spoedproductie",
  "pharma.feat7Desc": "24/7 beschikbaar voor urgente droogijsbestellingen. Spoedproductie en afhaling bij onze fabriek binnen enkele uren mogelijk.",
  "pharma.feat8Title": "UN-gecertificeerde verpakking",
  "pharma.feat8Desc": "Wij leveren verpakkingen die voldoen aan UN3373 en IATA-normen, geschikt voor medische en farmaceutische toepassingen.",
  "pharma.feat9Title": "Temperatuurmonitoring",
  "pharma.feat9Desc": "Optionele dataloggers kunnen worden meegeleverd om de temperatuur te registreren voor audit- en compliance-doeleinden.",
  "pharma.uc1Title": "Farmaceutische producten",
  "pharma.uc1Desc": "Droogijs voor het op temperatuur houden van vaccins, medicijnen, biologische preparaten en actieve ingrediënten (API's) op -79°C.",
  "pharma.uc2Title": "Laboratoriummonsters",
  "pharma.uc2Desc": "Droogijs voor het koelen van bloedmonsters, weefselsamples, DNA-materiaal en diagnostisch materiaal.",
  "pharma.uc3Title": "Klinische trials",
  "pharma.uc3Desc": "Betrouwbaar droogijs voor het bewaren van studiemateriaal en investigational medicinal products (IMP's).",
  "pharma.uc4Title": "Orgaan- & weefselopslag",
  "pharma.uc4Desc": "Droogijs voor tijdkritische koeling van medisch materiaal met gegarandeerde temperatuur.",
  "pharma.uc5Title": "Veterinaire diagnostiek",
  "pharma.uc5Desc": "Droogijs voor het op temperatuur houden van dierlijke monsters en vaccins voor veterinaire toepassingen.",
  "pharma.uc6Title": "Biotech & life sciences",
  "pharma.uc6Desc": "Droogijs voor het bewaren van celculturen, enzymen, reagentia en andere temperatuurgevoelige biotechnologische producten.",
  "pharma.faq1Q": "Hoeveel droogijs heb ik nodig?",
  "pharma.faq1A": "Dit hangt af van de bewaarduur, de grootte van de verpakking en het seizoen. Voor 24 uur adviseren wij minimaal 6 kg, voor 72 uur 10-15 kg. Neem contact op voor advies op maat.",
  "pharma.faq2Q": "Mag droogijs per vliegtuig vervoerd worden?",
  "pharma.faq2A": "Ja, mits correct verpakt en gelabeld conform IATA DGR. Wij leveren de juiste verpakkingen en documentatie. Voor het transport zelf verwijzen wij u naar gespecialiseerde logistieke partners.",
  "pharma.faq3Q": "Is jullie droogijs NEN-gecertificeerd?",
  "pharma.faq3A": "Ja, al ons droogijs is NEN-gecertificeerd en voldoet aan de strengste kwaliteitsnormen voor medische, farmaceutische en food-grade toepassingen.",
  "pharma.faq4Q": "Hoe snel kan een spoedbestelling geproduceerd worden?",
  "pharma.faq4A": "Bij urgente bestellingen kunnen wij binnen enkele uren produceren. Afhaling bij onze fabriek is 24/7 mogelijk.",
  "pharma.faq5Q": "Bieden jullie temperatuurgevalideerde verpakkingen aan?",
  "pharma.faq5A": "Ja, onze verpakkingen zijn gevalideerd voor temperatuurbereiken van -80°C tot -20°C en van 2°C tot 8°C.",
  "pharma.faq6Q": "Leveren jullie ook documentatie mee?",
  "pharma.faq6A": "Ja, bij elke bestelling leveren wij MSDS, kwaliteitscertificaten en eventuele aanvullende documentatie mee.",
  "pharma.ctaTitle": "Droogijs bestellen voor medische of farmaceutische toepassingen",
  "pharma.ctaText": "NEN-gecertificeerd biodroogijs, vers geproduceerd en snel geleverd voor uw koude keten.",

  // Transport & Logistiek
  "transport.badge": "Transport & Logistiek",
  "transport.title": "Droogijs voor",
  "transport.titleHighlight": "transport & logistiek",
  "transport.subtitle": "Betrouwbare koeling tijdens transport van temperatuurgevoelige goederen. FSSC ISO 22000 gecertificeerd biodroogijs in containers van 150 kg tot 440 kg.",
  "transport.stat1": "Maximaal per container",
  "transport.stat2": "Containerkosten",
  "transport.stat3": "ISO 22000 gecertificeerd",
  "transport.stat4": "Leveringsdagen",
  "transport.introTitle": "NEN-gecertificeerd droogijs voor transport en logistiek",
  "transport.intro1": "Voor de voedselindustrie, farmaceutische sector en logistieke bedrijven bieden wij NEN-gecertificeerd droogijs in grote hoeveelheden aan. Onze geïsoleerde containers zijn beschikbaar van 150 kg tot 440 kg en worden vers geproduceerd op de dag van levering.",
  "transport.intro2": "Aan het gebruik van de containers zijn geen kosten verbonden, u betaalt alleen voor het droogijs en het transport. Dit maakt het een kostenefficiënte oplossing voor bedrijven met een regelmatige behoefte.",
  "transport.intro3": "Met onze herhaalorders hoeft u slechts eenmaal in te stellen en ontvangt u automatisch uw droogijs op de gewenste frequentie. Onze productiecapaciteit is schaalbaar tot tientallen tonnen per dag.",
  "transport.intro4": "Wij werken samen met transportbedrijven, distributiecentra en logistieke dienstverleners door heel Nederland.",
  "transport.processTitle": "Van bestelling tot levering",
  "transport.step1Title": "Offerte op maat",
  "transport.step1Desc": "Bespreek uw behoeften met onze accountmanager. Wij stellen een maatwerkofferte samen op basis van volume, frequentie en leveringslocatie.",
  "transport.step2Title": "Productie op de dag zelf",
  "transport.step2Desc": "Uw NEN-gecertificeerd droogijs wordt vers geproduceerd op de dag van levering voor maximale kwaliteit.",
  "transport.step3Title": "Transport in geïsoleerde containers",
  "transport.step3Desc": "Het droogijs wordt in onze professionele containers geladen en bij u afgeleverd.",
  "transport.step4Title": "Container retour of hergebruik",
  "transport.step4Desc": "Na gebruik halen wij de containers weer op. Bij structurele afname kunt u containers op locatie houden.",
  "transport.feat1Title": "NEN-gecertificeerd",
  "transport.feat1Desc": "Al ons droogijs voldoet aan de strenge NEN-normen voor kwaliteit en voedselveiligheid.",
  "transport.feat2Title": "150 – 440 kg per container",
  "transport.feat2Desc": "Kies de hoeveelheid die past bij uw operatie. Meerdere containers per levering zijn mogelijk.",
  "transport.feat3Title": "Geen containerkosten",
  "transport.feat3Desc": "U betaalt alleen voor het droogijs en transport. Het gebruik van onze containers is volledig kosteloos.",
  "transport.feat4Title": "Vers geproduceerd",
  "transport.feat4Desc": "Altijd vers droogijs op de dag van levering voor maximale koelcapaciteit.",
  "transport.feat5Title": "Herhaalorders",
  "transport.feat5Desc": "Stel een terugkerend schema in en ontvang automatisch. Dagelijks, wekelijks of op maat.",
  "transport.feat6Title": "Flexibele levering",
  "transport.feat6Desc": "Dagelijkse, wekelijkse of maandelijkse levering mogelijk. dinsdag t/m vrijdag.",
  "transport.feat7Title": "24/7 spoedleveringen",
  "transport.feat7Desc": "Onverwacht meer nodig? Wij staan altijd klaar voor urgente leveringen.",
  "transport.feat8Title": "Betrouwbare levering",
  "transport.feat8Desc": "Snelle en betrouwbare leveringen door heel Nederland.",
  "transport.feat9Title": "Volumekortingen",
  "transport.feat9Desc": "Bij structurele afname bieden wij aantrekkelijke kortingen en vaste prijsafspraken.",
  "transport.uc1Title": "Koeltransport",
  "transport.uc1Desc": "Droogijs voor het waarborgen van de koelketen bij distributie van verse en bevroren producten.",
  "transport.uc2Title": "Distributiecentra",
  "transport.uc2Desc": "Droogijs op locatie voor het koelen van uitgaande producten en het bufferen van temperatuurgevoelige voorraden.",
  "transport.uc3Title": "Pharma-logistiek",
  "transport.uc3Desc": "Droogijs voor het op temperatuur houden van farmaceutische producten conform GDP-richtlijnen.",
  "transport.uc4Title": "Last-mile delivery",
  "transport.uc4Desc": "Droogijs in EPS-dozen voor de laatste schakel in de koelketen richting consument.",
  "transport.uc5Title": "Luchtvracht",
  "transport.uc5Desc": "Droogijs voor internationale luchtvrachttoepassingen met temperatuurvereisten.",
  "transport.uc6Title": "Warehousing",
  "transport.uc6Desc": "Tijdelijke koeling in warehouses bij uitval van koelinstallaties of piekbelasting.",
  "transport.faq1Q": "Hoeveel droogijs heb ik dagelijks nodig?",
  "transport.faq1A": "Dit hangt af van uw toepassing en het te koelen volume. Onze accountmanagers helpen u met een nauwkeurige berekening.",
  "transport.faq2Q": "Hoe lang blijft droogijs bruikbaar in de container?",
  "transport.faq2A": "In onze geïsoleerde containers blijft droogijs tot 5 dagen bruikbaar, afhankelijk van omstandigheden.",
  "transport.faq3Q": "Is jullie droogijs NEN-gecertificeerd?",
  "transport.faq3A": "Ja, al ons droogijs is NEN-gecertificeerd en geschikt voor food-grade en farmaceutische toepassingen.",
  "transport.faq4Q": "Leveren jullie ook in het weekend?",
  "transport.faq4A": "Ja, wij leveren dinsdag t/m vrijdag. Spoedleveringen ma-vr beschikbaar.",
  "transport.faq5Q": "Wat is de levertijd voor een eerste bestelling?",
  "transport.faq5A": "Na akkoord op de offerte kunnen wij meestal binnen 24-48 uur leveren. Bij spoed vaak nog dezelfde dag.",
  "transport.faq6Q": "Welke vormen droogijs leveren jullie?",
  "transport.faq6A": "Wij leveren pellets (3 mm, 10 mm en 16 mm), schijven en blokken. De juiste vorm hangt af van uw toepassing.",
  "transport.ctaTitle": "Vraag een offerte aan voor transport & logistiek",
  "transport.ctaText": "NEN-gecertificeerd droogijs in containers, op maat voor uw logistieke operatie.",

  // Industrieel reinigen
  "cleaning.badge": "Industrieel reinigen",
  "cleaning.title": "Industrieel reinigen",
  "cleaning.titleHighlight": "met droogijs",
  "cleaning.subtitle": "Milieuvriendelijk, effectief en zonder restafval. Wij leveren het droogijs, het stralen wordt uitgevoerd door onze gespecialiseerde partners.",
  "cleaning.stat1": "Temperatuur droogijs",
  "cleaning.stat2": "Restafval",
  "cleaning.stat3": "Biodroogijs",
  "cleaning.stat4": "Veilig",
  "cleaning.introTitle": "Hoe werkt droogijsstralen?",
  "cleaning.intro1": "Droogijsstralen (ook wel dry ice blasting genoemd) is een veelgebruikte methode om machines, apparatuur en voertuigen te reinigen. Het is effectief tegen vrijwel elke vorm van vervuiling: olie, vet, kleurstof, lijm, mos, roet, hars en meer.",
  "cleaning.intro2": "Door middel van perslucht worden NEN-gecertificeerde droogijspellets met hoge snelheid tegen het oppervlak gestraald. Door het enorme temperatuurverschil (-79°C) ontstaan micro-scheurtjes in de vervuilingslaag waardoor deze loslaat.",
  "cleaning.intro3": "Het droogijs sublimeert direct bij impact, er blijft geen water, zand, chemisch afval of ander restmateriaal achter. Dit maakt droogijsstralen fundamenteel anders dan traditionele reinigingsmethoden.",
  "cleaning.intro4": "Het resultaat: een schoon oppervlak zonder beschadiging, zonder demontage en met minimale stilstandtijd.",
  "cleaning.processTitle": "Het reinigingsproces",
  "cleaning.step1Title": "Bestel droogijspellets",
  "cleaning.step1Desc": "Bestel NEN-gecertificeerde 3 mm droogijspellets via ons platform. Wij leveren binnen 24 uur op uw locatie.",
  "cleaning.step2Title": "Vul de straalmachine",
  "cleaning.step2Desc": "Vul uw droogijsstraalmachine met de pellets. De meeste machines werken met standaard 3 mm pellets.",
  "cleaning.step3Title": "Straal de vervuiling weg",
  "cleaning.step3Desc": "Richt de straalslang op het te reinigen oppervlak. De pellets verwijderen vervuiling door thermische schok.",
  "cleaning.step4Title": "Klaar | geen opruimen nodig",
  "cleaning.step4Desc": "Het droogijs sublimeert volledig. U hoeft alleen de losgestraalde vervuiling op te ruimen.",
  "cleaning.feat1Title": "NEN-gecertificeerd",
  "cleaning.feat1Desc": "Ons droogijs voldoet aan de strenge NEN-normen voor kwaliteit, ook voor gebruik in de voedselindustrie.",
  "cleaning.feat2Title": "Geen restafval",
  "cleaning.feat2Desc": "Droogijs sublimeert volledig, er blijft niets achter op het oppervlak.",
  "cleaning.feat3Title": "Milieuvriendelijk",
  "cleaning.feat3Desc": "Geen chemicaliën, geen water, geen secundair afval. Minimale ecologische voetafdruk.",
  "cleaning.feat4Title": "Niet-abrasief",
  "cleaning.feat4Desc": "Beschadigt het onderliggende oppervlak niet, ideaal voor gevoelige apparatuur en delicate materialen.",
  "cleaning.feat5Title": "Geen demontage nodig",
  "cleaning.feat5Desc": "Machines en apparatuur kunnen in-situ gereinigd worden, zonder uit elkaar te halen.",
  "cleaning.feat6Title": "ATEX-veilig",
  "cleaning.feat6Desc": "Geschikt voor gebruik in explosiegevaarlijke omgevingen. Geen vonken, geen vlammen.",
  "cleaning.feat7Title": "Snel en efficiënt",
  "cleaning.feat7Desc": "Minder stilstand door snelle reinigingscycli. Machines zijn direct na reiniging weer inzetbaar.",
  "cleaning.feat8Title": "Veelzijdig inzetbaar",
  "cleaning.feat8Desc": "Effectief op metaal, kunststof, rubber, beton, hout en meer.",
  "cleaning.feat9Title": "Kostenbesparend",
  "cleaning.feat9Desc": "Bespaart op arbeid, stilstand, water- en afvalverwerking ondanks hogere initiële kosten.",
  "cleaning.uc1Title": "Productie-industrie",
  "cleaning.uc1Desc": "Matrijzen, vormen, spuitgietmachines en productie-apparatuur reinigen zonder stilstand.",
  "cleaning.uc2Title": "Voedselindustrie",
  "cleaning.uc2Desc": "Hygiënisch reinigen van ovens, baklijnen, transportbanden en verpakkingsmachines. HACCP-compliant.",
  "cleaning.uc3Title": "Automotive & transport",
  "cleaning.uc3Desc": "Motoren, onderstellen, carrosseriedelen en historische voertuigen schoonmaken zonder beschadiging.",
  "cleaning.uc4Title": "Restauratie & bouw",
  "cleaning.uc4Desc": "Gevelreiniging, graffitiverwijdering, restauratie van monumenten en verwijdering van brandschade.",
  "cleaning.uc5Title": "Scheepvaart",
  "cleaning.uc5Desc": "Reiniging van scheepsmotoren, dekken en laadruimtes zonder watergebruik in havengebieden.",
  "cleaning.uc6Title": "Elektrotechniek",
  "cleaning.uc6Desc": "Veilig reinigen van schakelkasten, transformatoren en elektrische installaties zonder kortsluiting.",
  "cleaning.faq1Q": "Welke droogijspellets heb ik nodig voor stralen?",
  "cleaning.faq1A": "Voor droogijsstralen zijn NEN-gecertificeerde 3 mm pellets de standaard. Deze passen in vrijwel alle gangbare straalmachines.",
  "cleaning.faq2Q": "Hoeveel droogijs verbruik ik per uur stralen?",
  "cleaning.faq2A": "Gemiddeld verbruikt u 30-80 kg per uur, afhankelijk van de machine-instelling en het type vervuiling.",
  "cleaning.faq3Q": "Beschadigt droogijsstralen het oppervlak?",
  "cleaning.faq3A": "Nee, droogijsstralen is niet-abrasief. Het verwijdert vervuiling door thermische schok, niet door slijping.",
  "cleaning.faq4Q": "Is droogijsstralen luidruchtig?",
  "cleaning.faq4A": "Ja, door de perslucht produceert droogijsstralen geluidsniveaus van 90-110 dB. Gehoorbescherming is verplicht.",
  "cleaning.faq5Q": "Is jullie droogijs NEN-gecertificeerd?",
  "cleaning.faq5A": "Ja, al ons droogijs is NEN-gecertificeerd en voldoet aan de strenge kwaliteitsnormen voor industrieel en food-grade gebruik.",
  "cleaning.faq6Q": "Hoe bewaar ik droogijspellets tot gebruik?",
  "cleaning.faq6A": "Bewaar de pellets in de geïsoleerde verpakking op een goed geventileerde plek. Gebruik ze bij voorkeur binnen 24 uur.",
  "cleaning.ctaTitle": "NEN-gecertificeerd droogijs voor reiniging",
  "cleaning.ctaText": "Bestel 3 mm droogijspellets voor uw straalmachine. Levering binnen 24 uur op uw locatie.",

  // Evenementen
  "events.badge": "Evenementen",
  "events.title": "Droogijs voor",
  "events.titleHighlight": "evenementen & festivals",
  "events.subtitle": "Spectaculaire rookeffecten, koeling van dranken en sfeervolle presentaties. Droogijs maakt elk evenement onvergetelijk.",
  "events.stat1": "Minimale bestelling",
  "events.stat2": "Biodroogijs",
  "events.stat3": "ISO 22000 gecertificeerd",
  "events.stat4": "Spoedlevering",
  "events.introTitle": "Droogijs op je evenement",
  "events.intro1": "Van bruiloften en bedrijfsfeesten tot festivals en productlanceringen, droogijs creëert een magische sfeer die je gasten niet snel vergeten. De dichte, laaghangende mist van droogijs is hét spectaculaire effect voor elke gelegenheid.",
  "events.intro2": "Naast visuele effecten is droogijs ook een praktische koeloplossing voor evenementen. Koel dranken, houd catering op temperatuur en bewaar verse producten zonder stroomaansluiting. Droogijs sublimeert volledig en laat geen water of afval achter.",
  "events.intro3": "Wij leveren NEN-gecertificeerd droogijs in elke gewenste hoeveelheid, van kleine bestellingen voor een intieme setting tot grote volumes voor meerdaagse festivals. Levering op locatie, ook buiten kantooruren.",
  "events.intro4": "Ons team adviseert je graag over de juiste hoeveelheid en toepassing voor jouw evenement. Of je nu rookeffecten wilt bij de openingsdans of koeling nodig hebt voor een foodtruck-festival, wij denken mee.",
  "events.processTitle": "Zo regel je droogijs voor je evenement",
  "events.step1Title": "Bestel via ons platform",
  "events.step1Desc": "Geef aan hoeveel droogijs je nodig hebt, in welke vorm en wanneer het geleverd moet worden.",
  "events.step2Title": "Wij adviseren je",
  "events.step2Desc": "Onze eventspecialisten adviseren over de juiste hoeveelheid op basis van je ruimte, duur en gewenste effecten.",
  "events.step3Title": "Levering op locatie",
  "events.step3Desc": "Wij leveren het droogijs op de afgesproken datum en tijd, direct op de evenementlocatie.",
  "events.step4Title": "Veiligheidsinstructies",
  "events.step4Desc": "Bij levering ontvang je heldere veiligheidsinstructies voor het veilig gebruik van droogijs op je evenement.",
  "events.feat1Title": "Spectaculaire rookeffecten",
  "events.feat1Desc": "Dichte, laaghangende mist voor openingsdansen, productpresentaties en theatrale momenten.",
  "events.feat2Title": "Koeling zonder stroom",
  "events.feat2Desc": "Koel dranken, buffetten en catering zonder zware koelinstallaties of stroomaansluiting.",
  "events.feat3Title": "NEN-gecertificeerd",
  "events.feat3Desc": "Ons droogijs voldoet aan de strenge NEN-normen voor kwaliteit en voedselveiligheid.",
  "events.feat4Title": "Geen restafval",
  "events.feat4Desc": "Droogijs sublimeert volledig, geen water, geen rommel, geen opruimen na afloop.",
  "events.feat5Title": "Flexibele hoeveelheden",
  "events.feat5Desc": "Van 6 kg voor een intieme bruiloft tot honderden kg voor een festival, wij leveren op maat.",
  "events.feat6Title": "Levering op locatie",
  "events.feat6Desc": "Wij bezorgen direct op de evenementlocatie, ook in het weekend en 's avonds.",
  "events.feat7Title": "Veilig gebruik",
  "events.feat7Desc": "Inclusief veiligheidsinstructies en advies over het correcte gebruik op je evenement.",
  "events.feat8Title": "24/7 spoedservice",
  "events.feat8Desc": "Last-minute extra nodig? Wij leveren ook op korte termijn, 24/7 bereikbaar.",
  "events.feat9Title": "Pellets, schijven of blokken",
  "events.feat9Desc": "Kies de vorm die het beste past: pellets voor snel effect, blokken voor langdurige koeling.",
  "events.uc1Title": "Bruiloften",
  "events.uc1Desc": "Romantische rookeffecten bij de openingsdans, het aansnijden van de taart of de entree van het bruidspaar.",
  "events.uc2Title": "Bedrijfsevenementen",
  "events.uc2Desc": "Productlanceringen, gala's en personeelsfeesten met spectaculaire visuele effecten.",
  "events.uc3Title": "Festivals & concerten",
  "events.uc3Desc": "Sfeervolle mist op podia, koeling van drankstands en verse food op temperatuur houden.",
  "events.uc4Title": "Beurzen & exposities",
  "events.uc4Desc": "Opvallende standpresentaties met rookeffecten die bezoekers aantrekken en onthouden.",
  "events.uc5Title": "Horeca-evenementen",
  "events.uc5Desc": "Pop-up diners, wijnproeverijen en cocktailparty's met theatrale drankpresentaties.",
  "events.uc6Title": "Film- & fotoproducties",
  "events.uc6Desc": "Professionele misteffecten voor film, televisie en fotoshoots zonder machines.",
  "events.faq1Q": "Hoeveel droogijs heb ik nodig voor mijn evenement?",
  "events.faq1A": "Dit hangt af van het gewenste effect en de duur. Voor rookeffecten bij een bruiloft is 6-10 kg vaak voldoende. Voor een heel festival adviseren wij 50+ kg. Wij helpen je graag met een inschatting.",
  "events.faq2Q": "Is droogijs veilig op een evenement met gasten?",
  "events.faq2A": "Ja, mits correct gebruikt. Droogijs mag niet met blote handen worden aangeraakt en moet in goed geventileerde ruimtes worden gebruikt. Wij leveren altijd veiligheidsinstructies mee.",
  "events.faq3Q": "Hoe lang houdt het rookeffect aan?",
  "events.faq3A": "Het rookeffect duurt 5-15 minuten per toepassing, afhankelijk van de hoeveelheid droogijs en de temperatuur van het water. Pellets geven een sneller maar korter effect dan blokken.",
  "events.faq4Q": "Kan ik droogijs combineren met warm water?",
  "events.faq4A": "Ja, warm water versnelt de sublimatie en geeft een intenser rookeffect. Dit is de standaard methode voor visuele effecten op evenementen.",
  "events.faq5Q": "Leveren jullie ook in het weekend?",
  "events.faq5A": "Ja, wij leveren 7 dagen per week, inclusief in het weekend en op feestdagen. Spoedleveringen zijn 24/7 beschikbaar.",
  "events.ctaTitle": "Droogijs bestellen voor je evenement",
  "events.ctaText": "Maak je evenement onvergetelijk met spectaculaire rookeffecten en betrouwbare koeling.",

  // Contact popup
  "contact.popup.title": "Contact opnemen",
  "contact.popup.form": "Contactformulier",
  "contact.popup.formDesc": "Stuur ons een bericht",
  "contact.popup.call": "Bel ons",
  "contact.popup.email": "E-mail",
  "contact.popup.ariaLabel": "Contact opnemen",


  // Admin Overview
  "admin.overviewTitle": "Overzicht",
  "admin.ordersLabel": "Bestellingen",
  "admin.active": "Actief",
  "admin.totalRevenue": "Totale omzet",
  "admin.invoicesLabel": "Facturen",
  "admin.paid": "Betaald",
  "admin.outstanding": "Openstaand",
  "admin.subscriptions": "Abonnementen",
  "admin.customersLabel": "Klanten",
  "admin.week": "Week",
  "admin.month": "Maand",
  "admin.noSubscriptions": "Geen lopende abonnementen",
  "admin.orderNumber": "Ordernummer",
  "admin.client": "Klant",
  "admin.frequency": "Frequentie",
  "admin.contractType": "Contractvorm",
  "admin.progress": "Voortgang",
  "admin.status": "Status",
  "admin.price": "Prijs",
  "admin.weekly": "Wekelijks",
  "admin.biweekly": "Tweewekelijks",
  "admin.monthly": "Maandelijks",
  "admin.nOrders": "bestellingen",
  "admin.indefinite": "Onbepaalde tijd",
  "admin.placed": "geplaatst",
  "admin.activeOrders": "Actieve Bestellingen",
  "admin.noActiveOrders": "Geen actieve bestellingen",
  "admin.type": "Type",
  "admin.destination": "Bestemming",
  "admin.date": "Datum",
  "admin.actions": "Acties",
  "admin.confirm": "Bevestigen",
  "admin.deleteConfirm": "Weet je zeker dat je bestelling {0} wilt verwijderen?",
  "admin.recentInvoices": "Recente Facturen",
  "admin.outstandingAmount": "openstaand",
  "admin.allInvoices": "Alle facturen",
  "admin.invoiceNumber": "Factuurnummer",
  "admin.amount": "Bedrag",
  "admin.noInvoices": "Geen facturen gevonden",
  "admin.notInvoiced": "Niet gefactureerd",
  "admin.invoiced": "Gefactureerd",
  "admin.sent": "Verzonden",
  "admin.overdue": "Verlopen",
  "admin.cancelled": "Geannuleerd",
  "admin.downloadedInvoice": "Factuur gedownload",
  "admin.downloadedInvoiceDesc": "Factuur {0} is gedownload.",

  // Admin Roles
  "admin.roleBeheerder": "Beheerder",
  "admin.roleAccountmanager": "Accountmanager",
  "admin.roleGebruiker": "Gebruiker",
  "admin.roleKlant": "Klant",
  "admin.roleOntvanger": "Ontvanger",

  // Order statuses
  "admin.statusDraft": "Concept",
  "admin.statusSubmitted": "Ingediend",
  "admin.statusAwaitingPayment": "Wacht op betaling",
  "admin.statusAwaitingApproval": "Pro forma",
  "admin.statusConfirmed": "Bevestigd",
  "admin.statusInProduction": "In productie",
  "admin.statusReady": "Staat klaar",
  "admin.statusShipped": "Verzonden",
  "admin.statusCompleted": "Afgerond",
  "admin.statusCancelled": "Geannuleerd",
  "admin.statusDelivered": "Geleverd",
  "admin.statusInTransit": "Onderweg",

  // Order types
  "admin.typeEpsDryice": "EPS Droogijs",
  "admin.typeLargeExport": "Grote Export",
  "admin.typeSmallExport": "Kleine Export",

  // Orders Tab
  "admin.total": "Totaal",
  "admin.ordersTitle": "Bestellingen",
  "admin.searchOrders": "Zoek op ordernummer, bedrijf...",
  "admin.filterStatus": "Filter op status",
  "admin.allStatuses": "Alle statussen",
  "admin.noOrdersFound": "Geen bestellingen gevonden",
  "admin.deliveryMoment": "Bezorgmoment",
  "admin.send": "Verzenden",
  "admin.cancelConfirm": "Weet je zeker dat je bestelling {0} wilt annuleren?",

  // Shipments Tab
  "admin.shipmentsTitle": "Verzendingen",
  "admin.searchShipments": "Zoek op order, bedrijf, tracking...",
  "admin.trackTrace": "Track & Trace",
  "admin.carrier": "Vervoerder",
  "admin.noShipments": "Geen verzendingen gevonden",

  // Production Tab
  "admin.waiting": "Wachtend",
  "admin.inProduction": "In productie",
  "admin.noInProduction": "Geen orders in productie",
  "admin.noWaiting": "Geen wachtende orders",
  "admin.noProductionOrders": "Geen productieopdrachten",
  "admin.noProductionDesc": "Er zijn momenteel geen bestellingen die klaargemaakt moeten worden.",
  "admin.markShipped": "Verzonden",
  "admin.start": "Start",
  "admin.shipOrder": "Order verzenden",
  "admin.shipOrderDesc": "Markeer order {0} als verzonden (klaar voor ophalen door vervoerder).",
  "admin.productionNotes": "Productie notities (optioneel)",
  "admin.productionNotesPlaceholder": "Bijv. extra verpakkingsmateriaal toegevoegd...",
  "admin.cancel": "Annuleren",

  // Customers Tab
  "admin.customerManagement": "Klantenbeheer",
  "admin.companies": "bedrijven",
  "admin.searchCompanies": "Zoek bedrijven...",
  "admin.allTypes": "Alle types",
  "admin.existingCustomer": "Bestaande klant",
  "admin.platformCustomer": "Platform klant",
  "admin.newCustomer": "Nieuwe klant",
  "admin.addCustomer": "Nieuwe klant toevoegen",
  "admin.addCustomerDesc": "Voeg een nieuwe klant toe aan het platform.",
  "admin.companyName": "Bedrijfsnaam",
  "admin.city": "Plaats",
  "admin.vatNumber": "BTW-nummer",
  "admin.add": "Toevoegen",
  "admin.editCustomer": "Klant bewerken",
  "admin.editCustomerDesc": "Pas de gegevens van deze klant aan.",
  "admin.save": "Opslaan",
  "admin.deleteCustomer": "Klant verwijderen",
  "admin.deleteCustomerConfirm": "Weet je zeker dat je deze klant wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "admin.delete": "Verwijderen",
  "admin.noCompaniesFound": "Geen bedrijven gevonden voor",
  "admin.noCompaniesYet": "Nog geen bedrijven geregistreerd",
  "admin.company": "Bedrijf",
  "admin.location": "Locatie",
  "admin.sector": "Sector",
  "admin.trusted": "Vertrouwd",
  "admin.contacts": "Contacten",
  "admin.subscription": "Abonnement",
  "admin.openInvoices": "Open facturen",
  "admin.action": "Actie",
  "admin.platform": "Platform",
  "admin.existing": "Bestaand",
  "admin.open": "open",
  "admin.companyCreated": "Bedrijf aangemaakt",
  "admin.companyCreatedDesc": "{0} is toegevoegd.",
  "admin.customerUpdated": "Klant bijgewerkt",
  "admin.customerUpdatedDesc": "{0} is aangepast.",
  "admin.customerDeleted": "Klant verwijderd",
  "admin.error": "Fout",

  // Users Tab
  "admin.allUsers": "Alle gebruikers",
  "admin.registeredUsers": "geregistreerde gebruikers",
  "admin.searchUsers": "Zoek gebruikers...",
  "admin.export": "Export",
  "admin.addUser": "Toevoegen",
  "admin.everyone": "Iedereen",
  "admin.admins": "Beheerders",
  "admin.accountManagers": "Accountmanagers",
  "admin.usersFilter": "Gebruikers",
  "admin.roleUpdated": "Rol bijgewerkt",
  "admin.roleUpdatedDesc": "De gebruikersrol is opgeslagen.",
  "admin.roleSaveError": "Fout bij opslaan",
  "admin.userDeleted": "Gebruiker verwijderd",
  "admin.userDeletedDesc": "Het account is succesvol verwijderd.",
  "admin.deleteError": "Fout bij verwijderen",
  "admin.impersonationActiveTitle": "Impersonatie actief",
  "admin.impersonationActiveDesc": "Je bent nu ingelogd als {0}",
  "admin.inviteSent": "Uitnodiging verstuurd",
  "admin.inviteSentDesc": "Uitnodiging verstuurd naar {0}",
  "admin.passwordResetSent": "Wachtwoord reset verstuurd",
  "admin.passwordResetSentDesc": "Reset-link verstuurd naar {0}",
  "admin.exportStarted": "Export gestart",
  "admin.exportStartedDesc": "{0} gebruikers worden geëxporteerd",

  // Invoices Tab
  "admin.totalRevenueLabel": "Totale omzet",
  "admin.paidLabel": "Betaald",
  "admin.outstandingLabel": "Openstaand",
  "admin.totalInvoices": "Totaal facturen",
  "admin.allInvoicesTitle": "Alle facturen",
  "admin.searchInvoices": "Zoek op nummer, bedrijf...",
  "admin.invoiceSettings": "Factuurinstellingen",
  "admin.invoicePaid": "Factuur betaald",
  "admin.invoicePaidDesc": "Factuur {0} is als betaald gemarkeerd.",
  "admin.invoiceDownloaded": "Factuur gedownload",
  "admin.invoiceDownloadedDesc": "Factuur {0} is gedownload als PDF.",
  "admin.downloadFailed": "Download mislukt",
  "admin.downloadFailedDesc": "Er ging iets mis bij het genereren van de PDF.",
  "admin.today": "Vandaag",
  "admin.day": "dag",
  "admin.days": "dagen",
  "admin.openLabel": "Open",
  "admin.view": "Bekijken",
  "admin.markPaid": "Betaald",
  "admin.openSince": "Open sinds",
  "admin.paidOn": "Betaald",

  // Shipping Dialog
  "admin.registerShipment": "Verzending registreren",
  "admin.registerShipmentDesc": "Vul de verzendgegevens in voor bestelling {0}. De klant ontvangt automatisch een bevestiging.",
  "admin.transport": "Vervoer",
  "admin.selectCarrier": "Selecteer vervoerder",
  "admin.trackingCode": "Track & Trace code",
  "admin.trackingLink": "Track & Trace link",
  "admin.autoGenerated": "Automatisch gegenereerd op basis van vervoerder",
  "admin.confirmShipment": "Verzending bevestigen",
  "admin.processing": "Verwerken...",
  "admin.shipmentConfirmed": "Verzending bevestigd",
  "admin.shipmentConfirmedDesc": "Track & trace {0} opgeslagen en klant genotificeerd.",
  "admin.shipmentError": "Er ging iets mis bij het verwerken van de verzending.",

  // Access modules
  "admin.moduleOrders": "Bestellingen",
  "admin.moduleShipments": "Zendingen",
  "admin.moduleCustomers": "Klanten",
  "admin.moduleUsers": "Gebruikers",
  "admin.moduleInvoices": "Facturen",
  "admin.moduleProduction": "Productie",
  "admin.moduleCostCalc": "Kostprijs",

  // Admin | Helpdesk
  "admin.helpdesk.tickets": "Tickets",
  "admin.helpdesk.sentEmails": "Verzonden",
  "admin.helpdesk.statusOpen": "Open",
  "admin.helpdesk.statusInProgress": "In behandeling",
  "admin.helpdesk.statusWaiting": "Wacht op reactie",
  "admin.helpdesk.statusResolved": "Afgehandeld",
  "admin.helpdesk.priorityLow": "Laag",
  "admin.helpdesk.priorityNormal": "Normaal",
  "admin.helpdesk.priorityHigh": "Hoog",
  "admin.helpdesk.priorityUrgent": "Urgent",
  "admin.helpdesk.deliverySent": "Verzonden",
  "admin.helpdesk.deliveryPending": "In wachtrij",
  "admin.helpdesk.deliveryFailed": "Mislukt",
  "admin.helpdesk.noTickets": "Geen tickets",
  "admin.helpdesk.noTicketsAll": "Er zijn nog geen supporttickets binnengekomen.",
  "admin.helpdesk.noTicketsStatus": "Geen tickets met deze status.",
  "admin.helpdesk.allTickets": "Alle tickets",
  "admin.helpdesk.inProgress": "in behandeling",
  "admin.helpdesk.totalLabel": "totaal",
  "admin.helpdesk.customerMessage": "Bericht van klant",
  "admin.helpdesk.emailThread": "E-mailgesprek",
  "admin.helpdesk.quickReply": "Snel reageren",
  "admin.helpdesk.sendReply": "Versturen",
  "admin.helpdesk.extended": "Uitgebreid",
  "admin.helpdesk.deleteTicket": "Verwijderen",
  "admin.helpdesk.internalNote": "Interne notitie",
  "admin.helpdesk.internalNotePlaceholder": "Voeg een interne notitie toe...",
  "admin.helpdesk.saveNote": "Notitie opslaan",
  "admin.helpdesk.noSentEmails": "Geen verzonden e-mails",
  "admin.helpdesk.noSentEmailsDesc": "Verstuur je eerste e-mail via de knop hierboven.",
  "admin.helpdesk.replyTitle": "Reactie versturen",
  "admin.helpdesk.newEmail": "Nieuwe e-mail",
  "admin.helpdesk.replyDesc": "Stuur een antwoord naar de klant.",
  "admin.helpdesk.newEmailDesc": "Stuur een e-mail vanuit info@dutchdryice.com.",
  "admin.helpdesk.to": "Aan",
  "admin.helpdesk.subject": "Onderwerp",
  "admin.helpdesk.message": "Bericht",
  "admin.helpdesk.sentFrom": "Wordt verzonden vanaf: info@dutchdryice.com",
  "admin.helpdesk.reaction": "reactie",
  "admin.helpdesk.reactions": "reacties",
  "admin.helpdesk.replyPlaceholder": "Typ je antwoord aan {0}...",
  "admin.helpdesk.emailPlaceholder": "email@voorbeeld.nl",
  "admin.helpdesk.subjectPlaceholder": "Onderwerp van de e-mail",
  "admin.helpdesk.messagePlaceholder": "Typ je bericht...",

  // Admin | SLA Monitor
  "admin.sla.total": "Totaal",
  "admin.sla.deliveryRate": "Bezorghitrate",
  "admin.sla.delivered": "geleverd",
  "admin.sla.onTimeRate": "Op tijd ratio",
  "admin.sla.onTime": "op tijd",
  "admin.sla.avgDelivery": "Gem. levertijd",
  "admin.sla.completedLabel": "Afgeleverd",
  "admin.sla.failedLabel": "Mislukt / Onbekend",
  "admin.sla.lateNow": "Nu te laat",
  "admin.sla.pastDeadline": "Bestellingen voorbij deadline",
  "admin.sla.pastDeadlineDesc": "Deze bestellingen zijn nog niet afgeleverd maar hebben de beloofde levertijd overschreden.",
  "admin.sla.hoursLate": "u te laat",
  "admin.sla.activeOrders": "Lopende bestellingen",
  "admin.sla.activeOrdersDesc": "Bestellingen die nog niet afgeleverd zijn",
  "admin.sla.orderDate": "Orderdatum",
  "admin.sla.deadline": "Deadline",
  "admin.sla.late": "Te laat",
  "admin.sla.deliveryHistory": "Leveringshistorie",
  "admin.sla.deliveryHistoryDesc": "Overzicht van alle afgeleverde bestellingen",
  "admin.sla.noCompleted": "Nog geen afgeleverde bestellingen",
  "admin.sla.deliveryDate": "Leverdatum",
  "admin.sla.leadTime": "Doorlooptijd",
  "admin.sla.loading": "Laden...",
  "admin.sla.statusSubmitted": "Ingediend",
  "admin.sla.statusConfirmed": "Bevestigd",
  "admin.sla.statusInProduction": "In productie",
  "admin.sla.statusShipped": "Onderweg",
  "admin.sla.statusCompleted": "Afgeleverd",

  // Admin | Audit Log
  "admin.audit.title": "Audit Log",
  "admin.audit.description": "Overzicht van alle wijzigingen in het systeem",
  "admin.audit.allTypes": "Alle types",
  "admin.audit.orders": "Bestellingen",
  "admin.audit.users": "Gebruikers",
  "admin.audit.customers": "Klanten",
  "admin.audit.invoices": "Facturen",
  "admin.audit.settings": "Instellingen",
  "admin.audit.noEntries": "Geen audit entries gevonden",
  "admin.audit.autoLogged": "Wijzigingen worden automatisch gelogd",
  "admin.audit.system": "Systeem",
  "admin.audit.loading": "Laden...",

  // Admin | Settings / Process
  "admin.process.processes": "Processen",
  "admin.process.emailTemplates": "E-mail Templates",
  "admin.process.customerMgmt": "Klantbeheer",
  "admin.process.apiSettings": "API-koppelingen",
  "admin.process.orderTransitions": "Statusovergangen bestellingen",
  "admin.process.orderTransitionsDesc": "Configureer welke berichten en notificaties verstuurd worden bij elke statusovergang.",
  "admin.process.transitionsFooter": "Actieve regels genereren automatisch in-app notificaties bij statusovergangen van bestellingen.",
  "admin.process.triggerName": "Trigger naam",
  "admin.process.customer": "Klant",
  "admin.process.messageTemplate": "Berichttemplate",
  "admin.process.notifyStaff": "Medewerkers notificeren",
  "admin.process.noRecipients": "Geen ontvangers",
  "admin.process.selected": "geselecteerd",
  "admin.process.noUsersWithRole": "Geen gebruikers met deze rol",
  "admin.process.saved": "Transitieregel opgeslagen",
  "admin.process.autoConfirmTitle": "Automatische orderbevestiging",
  "admin.process.autoConfirmDesc": "Bestellingen die aan de onderstaande criteria voldoen worden automatisch bevestigd zonder handmatige controle.",
  "admin.process.active": "Actief",
  "admin.process.disabled": "Uitgeschakeld",
  "admin.process.maxWeight": "Maximaal gewicht (kg)",
  "admin.process.aboveMaxWeight": "Bestellingen boven {0} kg vereisen handmatige controle.",
  "admin.process.domesticOnly": "Alleen binnenlandse bestellingen",
  "admin.process.domesticOnlyDesc": "Internationale bestellingen vereisen altijd handmatige controle.",
  "admin.process.autoConfirmSaved": "Auto-bevestiging instellingen opgeslagen",
  "admin.process.autoConfirmDisabledNote": "Bij uitgeschakeld blijven alle bestellingen op \"Ingediend\" staan totdat een beheerder ze handmatig bevestigt.",
  "admin.process.inactivityTitle": "Klant inactiviteit",
  "admin.process.inactivityDesc": "Stel in na hoeveel dagen zonder bestellingen een klant automatisch op non-actief wordt gezet.",
  "admin.process.inactivitySaved": "Inactiviteitsdrempel opgeslagen",
  "admin.process.inactivityNote": "Na dit aantal dagen zonder activiteit ontvangt de klant een heractivatie-mail en wordt het bedrijf op non-actief gezet.",
  "admin.process.carrierApiTitle": "API-instellingen vervoerders",
  "admin.process.carrierApiDesc": "Configureer API-koppelingen voor live tarieven, labelgeneratie en tracking.",
  "admin.process.apiKey": "API Key",
  "admin.process.environment": "Omgeving",
  "admin.process.testSandbox": "Test / Sandbox",
  "admin.process.production": "Productie",
  "admin.process.activateLiveRates": "Activeer live tariefopvraag",
  "admin.process.testConnection": "Test verbinding",
  "admin.process.apiKeysNote": "API-keys worden veilig opgeslagen. Bij inactieve koppeling worden de handmatige tarieven uit Kostprijsberekening gebruikt.",
  "admin.process.inactive": "Inactief",

  // Admin | Settings page (AdminSettingsPage)
  "admin.settings.departments": "Afdelingen",
  "admin.settings.departmentsDesc": "Interne bedrijfsafdelingen.",
  "admin.settings.customerDepts": "Klant-afdelingen",
  "admin.settings.customerDeptsDesc": "Afdelingstypen die klanten kunnen kiezen.",
  "admin.settings.roles": "Rollen",
  "admin.settings.rolesDesc": "Beschikbare gebruikersrollen in het systeem.",
  "admin.settings.customerRoles": "Klantrollen",
  "admin.settings.customerRolesDesc": "Rollen voor externe klanten.",
  "admin.settings.accessRights": "Toegangsrechten",
  "admin.settings.accessRightsDesc": "Bepaal welke admin-pagina's per rol zichtbaar zijn.",
  "admin.settings.roleDashboard": "Pagina zichtbaar per rol:",
  "admin.settings.npsReviews": "NPS & Reviews",
  "admin.settings.slaMonitor": "SLA Monitor",

  // Admin | Overview hardcoded strings
  "admin.overview.subscriptionsCount": "Abonnementen ({0})",
  "admin.overview.loading": "Laden...",

  // Shop page
  "shop.ticker.certified": "NEN-gecertificeerd droogijs | voldoet aan de strengste kwaliteitsnormen.",
  "shop.ticker.sublimation": "Sublimatieverlies: reken ~10% extra droogijs mee voor transport.",
  "shop.ticker.temperature": "Droogijs sublimeert bij -78,5°C | ideaal voor de koudeketen.",
  "shop.ticker.epsRetention": "EPS-dozen houden de kou vast tot 72 uur, afhankelijk van hoeveelheid.",
  "shop.ticker.ventilation": "Gebruik droogijs altijd in goed geventileerde ruimtes (CO₂-risico).",
  "shop.ticker.discount": "Herhaalbestelling? Profiteer van staffelkorting tot 15%.",
  "shop.step.product": "Product",
  "shop.step.address": "Bezorgadres",
  "shop.step.delivery": "Levering",
  "shop.step.details": "Gegevens",
  "shop.step.payment": "Betaling",
  "shop.nav.certified": "NEN-gecertificeerd",
  "shop.nav.deliveryRate": "NEN-gecertificeerd",
  "shop.category.title": "Wat wil je bestellen?",
  "shop.category.subtitle": "Kies het type verpakking dat past bij jouw behoefte.",
  "shop.category.back": "Terug naar home",
  "shop.success.title": "Bestelling geplaatst!",
  "shop.success.description": "Je bestelling {0} is ontvangen en wordt verwerkt.",
  "shop.success.loggedIn": "Je bent automatisch ingelogd",
  "shop.success.loggedInDesc": "Je kunt direct je bestelling volgen en beheren in je klantenportaal.",
  "shop.success.backHome": "Terug naar home",
  "shop.success.toPortal": "Naar mijn portaal",
  "shop.product.title": "Kies je droogijs",
  "shop.product.subtitle": "Selecteer de verpakking en hoeveelheid die je nodig hebt.",
  "shop.subscription.label": "Terugkerende bestelling",
  "shop.subscription.title": "Herhaalbestelling",
  "shop.subscription.subtitle": "Ontvang automatisch droogijs op een vast schema",
  "shop.subscription.frequency": "Leverfrequentie",
  "shop.subscription.daily": "Per dag",
  "shop.subscription.weekly": "Wekelijks",
  "shop.subscription.biweekly": "2-wekelijks",
  "shop.subscription.monthly": "4-wekelijks",
  "shop.subscription.pickDays": "Op welke dag(en) wil je geleverd worden?",
  "shop.subscription.pickDaysHintMulti": "Selecteer meerdere dagen voor leveringen per week, bijv. dinsdag en vrijdag.",
  "shop.subscription.pickDaysHintSingle": "Kies de vaste leverdag per week.",
  "shop.subscription.mon": "Ma",
  "shop.subscription.tue": "Di",
  "shop.subscription.wed": "Wo",
  "shop.subscription.thu": "Do",
  "shop.subscription.fri": "Vr",
  "shop.subscription.sat": "Za",
  "shop.subscription.hint": "Je kunt je planning op elk moment wijzigen of pauzeren via je klantenportaal.",
  "shop.address.title": "Bezorgadres",
  "shop.address.subtitle": "Waar mogen we het droogijs afleveren?",
  "shop.address.company": "Bedrijfsnaam",
  "shop.address.companyPlaceholder": "Uw bedrijfsnaam",
  "shop.address.contact": "Contactpersoon",
  "shop.address.contactPlaceholder": "Naam contactpersoon",
  "shop.address.postalCode": "Postcode",
  "shop.address.houseNumber": "Huisnr.",
  "shop.address.street": "Straat",
  "shop.address.streetPlaceholder": "Straatnaam",
  "shop.address.city": "Plaats",
  "shop.address.cityPlaceholder": "Plaatsnaam",
  "shop.address.phone": "Telefoon",
  "shop.address.loading": "Laden...",
  "shop.delivery.title": "Bezorgmoment",
  "shop.delivery.subtitle": "Kies wanneer je het droogijs wilt ontvangen.",
  "shop.details.title": "Gegevens & bevestiging",
  "shop.details.subtitle": "Rond je bestelling af en krijg direct toegang tot je klantenportaal.",
  "shop.details.loggedInAs": "Ingelogd als {0}",
  "shop.details.loggedInDesc": "Je gegevens zijn automatisch ingevuld. De bestelling wordt aan je account gekoppeld.",
  "shop.details.email": "E-mailadres",
  "shop.details.emailPlaceholder": "info@uwbedrijf.nl",
  "shop.details.loginPrompt": "Al een account? Log hier in",
  "shop.details.login": "Inloggen",
  "shop.details.cancel": "Annuleer",
  "shop.details.emailLabel": "E-mailadres",
  "shop.details.passwordLabel": "Wachtwoord",
  "shop.details.passwordPlaceholder": "Kies een sterk wachtwoord",
  "shop.details.passwordHint": "min. 6 tekens",
  "shop.details.passwordOptional": "optioneel; account aanmaken",
  "shop.details.guestHint": "Laat leeg om als gast te bestellen. Je ontvangt inloggegevens per e-mail.",
  "shop.details.passwordError": "Wachtwoord moet minimaal 6 tekens zijn",
  "shop.details.kvk": "KvK-nummer",
  "shop.details.vat": "BTW-nummer",
  "shop.details.optional": "optioneel",
  "shop.details.instructions": "Bijzonderheden",
  "shop.details.instructionsPlaceholder": "Bijv. bellen bij aankomst, laden aan achterzijde...",
  "shop.summary.title": "Overzicht bestelling",
  "shop.summary.packaging": "Verpakking",
  "shop.summary.packagingIncl": "incl. in prijs",
  "shop.summary.delivery": "Bezorging",
  "shop.summary.subscription": "Herhaalbestelling",
  "shop.summary.totalExcl": "Totaal (excl. BTW)",
  "shop.summary.vat": "BTW 21%",
  "shop.summary.totalIncl": "Totaal (incl. BTW)",
  "shop.summary.deliveryAddress": "Bezorgadres",
  "shop.summary.total": "Totaal",
  "shop.summary.dryIce": "droogijs",
  "shop.summary.exclVat": "excl. BTW",
  "shop.summary.yourOrder": "Je bestelling",
  "shop.summary.noProducts": "Nog geen producten geselecteerd",
  "shop.summary.filled": "gevuld",
  "shop.summary.inclShort": "incl.",
  "shop.payment.title": "Betaalmethode",
  "shop.payment.subtitle": "Kies hoe je wilt betalen voor je bestelling.",
  "shop.payment.ideal": "iDEAL",
  "shop.payment.idealDesc": "Direct betalen via je bank",
  "shop.payment.idealSecure": "Veilig & direct verwerkt",
  "shop.payment.invoice": "Op factuur",
  "shop.payment.invoiceDesc": "Betaal op factuur voor de leverdatum. Wij leveren uit wanneer betaling ontvangen is",
  "shop.payment.invoicePortal": "Factuur zichtbaar in je portaal",
  "shop.payment.subtotal": "Subtotaal (excl. BTW)",
  "shop.payment.toPay": "Te betalen",
  "shop.payment.stripeRedirect": "Je wordt doorgestuurd naar een beveiligde betaalpagina van Stripe. Na succesvolle betaling kom je automatisch terug.",
  "shop.nav.previous": "Vorige",
  "shop.nav.back": "Terug",
  "shop.nav.next": "Volgende",
  "shop.nav.payIdeal": "Betaal met iDEAL",
  "shop.nav.placeOrder": "Bestelling plaatsen",
  "shop.nav.pay": "Betaal",
  "shop.nav.order": "Bestellen",
  "shop.trust.safeOrder": "Veilig bestellen",
  "shop.trust.ownDelivery": "Snelle bezorging",
  "shop.trust.deliveryRate": "NEN-gecertificeerd droogijs",
  "shop.trust.sameDay": "Vandaag besteld, vandaag geleverd",
  "shop.login.success": "Ingelogd! Je gegevens worden ingevuld.",
  "shop.login.failed": "Inloggen mislukt",
  "shop.error.general": "Er ging iets mis",
  "shop.error.orderFailed": "Bestelling kon niet worden geplaatst",
  "shop.error.paymentFailed": "Betaling starten mislukt",

  // Auth pages
  "auth.backHome": "Terug naar home",
  "auth.backToLogin": "Terug naar inloggen",
  "auth.login.title": "Welkom terug",
  "auth.login.subtitle": "Log in op je Dutch DryIce account",
  "auth.login.email": "E-mail",
  "auth.login.password": "Wachtwoord",
  "auth.login.forgotPassword": "Wachtwoord vergeten?",
  "auth.login.rememberMe": "Onthoud mij",
  "auth.login.loading": "Bezig met inloggen...",
  "auth.login.submit": "Inloggen",
  "auth.login.orContinueWith": "Of ga verder met",
  "auth.login.google": "Doorgaan met Google",
  "auth.login.noAccount": "Nog geen account?",
  "auth.login.register": "Registreren",
  "auth.login.terms": "Door verder te gaan ga je akkoord met onze",
  "auth.login.termsLink": "Algemene Voorwaarden",
  "auth.login.and": "en",
  "auth.login.privacyLink": "Privacybeleid",
  "auth.login.failed": "Inloggen mislukt",
  "auth.login.welcomeBack": "Welkom terug!",
  "auth.login.welcomeBackDesc": "Je bent succesvol ingelogd.",
  "auth.login.googleFailed": "Google login mislukt",
  "auth.login.welcome": "Welkom!",
  "auth.login.googleSuccess": "Je bent succesvol ingelogd via Google.",
  "auth.login.error": "Er is een fout opgetreden",
  "auth.signup.title": "Klantaccount aanmaken",
  "auth.signup.subtitle": "Registreer als klant om bestellingen te plaatsen en zendingen te volgen.",
  "auth.signup.firstName": "Voornaam",
  "auth.signup.lastName": "Achternaam",
  "auth.signup.company": "Bedrijfsnaam",
  "auth.signup.email": "Zakelijk e-mailadres",
  "auth.signup.password": "Wachtwoord",
  "auth.signup.passwordHint": "Minimaal 6 tekens",
  "auth.signup.confirmPassword": "Wachtwoord bevestigen",
  "auth.signup.loading": "Account aanmaken...",
  "auth.signup.submit": "Registreren als klant",
  "auth.signup.hasAccount": "Heb je al een account?",
  "auth.signup.login": "Inloggen",
  "auth.signup.terms": "Door een account aan te maken ga je akkoord met onze",
  "auth.signup.passwordMismatch": "Wachtwoorden komen niet overeen",
  "auth.signup.passwordMismatchDesc": "Controleer of beide wachtwoorden gelijk zijn.",
  "auth.signup.passwordTooShort": "Wachtwoord te kort",
  "auth.signup.passwordTooShortDesc": "Het wachtwoord moet minimaal 6 tekens bevatten.",
  "auth.signup.failed": "Registratie mislukt",
  "auth.signup.checkEmail": "Controleer je e-mail",
  "auth.signup.checkEmailDesc": "We hebben een bevestigingslink gestuurd om je account te activeren.",
  "auth.signup.googleFailed": "Google registratie mislukt",
  "auth.signup.googleWelcome": "Welkom!",
  "auth.signup.googleSuccess": "Je bent succesvol geregistreerd via Google.",
  "auth.forgot.title": "Wachtwoord vergeten",
  "auth.forgot.subtitle": "Vul je e-mailadres in om een resetlink te ontvangen",
  "auth.forgot.email": "E-mailadres",
  "auth.forgot.emailPlaceholder": "jij@bedrijf.com",
  "auth.forgot.loading": "Verzenden...",
  "auth.forgot.submit": "Resetlink versturen",
  "auth.forgot.sent": "E-mail verzonden",
  "auth.forgot.sentDesc": "Als er een account bestaat voor {0}, ontvang je een e-mail met een link om je wachtwoord te resetten.",
  "auth.forgot.error": "Fout",
  "auth.reset.title": "Nieuw wachtwoord instellen",
  "auth.reset.subtitle": "Kies een nieuw wachtwoord voor je account",
  "auth.reset.newPassword": "Nieuw wachtwoord",
  "auth.reset.confirmPassword": "Bevestig wachtwoord",
  "auth.reset.loading": "Opslaan...",
  "auth.reset.submit": "Wachtwoord opslaan",
  "auth.reset.success": "Wachtwoord gewijzigd",
  "auth.reset.successDesc": "Je wachtwoord is succesvol gewijzigd. Je wordt doorgestuurd naar de inlogpagina...",
  "auth.reset.invalidLink": "Deze link is ongeldig of verlopen. Vraag een nieuwe resetlink aan.",
  "auth.reset.newLink": "Nieuwe resetlink aanvragen",
  "auth.reset.passwordMismatch": "Wachtwoorden komen niet overeen",
  "auth.reset.passwordMismatchDesc": "Controleer of beide wachtwoorden identiek zijn.",
  "auth.reset.passwordTooShort": "Wachtwoord te kort",
  "auth.reset.passwordTooShortDesc": "Het wachtwoord moet minimaal 6 tekens bevatten.",
  "auth.reset.error": "Fout",

  // Delivery Scheduler
  "delivery.label": "Bezorgmoment *",
  "delivery.rush": "Spoedlevering",
  "delivery.rushDesc": "Vandaag binnen 2 uur · 08:00–22:00",
  "delivery.orChooseSlot": "Of kies een tijdslot",
  "delivery.chooseDay": "Kies een dag",
  "delivery.chooseSlot": "Kies een tijdslot",
  "delivery.today": "Vandaag",
  "delivery.tomorrow": "Morgen",
  "delivery.dayAfter": "Overmorgen",
  "delivery.otherDay": "Andere dag",
  "delivery.morning": "Ochtend",
  "delivery.afternoon": "Middag",
  "delivery.evening": "Avond",
  "delivery.within2hours": "Binnen 2 uur",
  "delivery.noSlots": "Geen tijdsloten beschikbaar voor deze dag",
  "delivery.pickDateFirst": "Eerst een ophaaldatum kiezen",
  "delivery.pickDateFirstDesc": "De leveringsopties zijn afhankelijk van je ophaaldatum.",
  "delivery.chooseCalendarDate": "Kies een datum in de kalender",

  // NewShipment wizard
  "wizard.chooseOrderType": "Kies je type bestelling",
  "wizard.chooseOrderTypeDesc": "Selecteer het type bestelling dat past bij jouw droogijsbehoefte",
  "wizard.backToDashboard": "Terug naar dashboard",
  "wizard.previous": "Terug",
  "wizard.next": "Volgende",
  "wizard.payWithIdeal": "Betaal met iDEAL",

  // Wizard steps
  "wizard.step.packaging": "Verpakking",
  "wizard.step.dryIce": "Droogijs",
  "wizard.step.deliveryAddress": "Bezorgadres",
  "wizard.step.deliveryMoment": "Bezorgmoment",
  "wizard.step.confirmation": "Bevestiging",
  "wizard.step.payment": "Betaling",
  "wizard.step.product": "Product",
  "wizard.step.pickupLocation": "Ophaallocatie",
  "wizard.step.pickupMoment": "Ophaalmoment",
  "wizard.step.route": "Route",
  "wizard.step.confirm": "Bevestig",
  "wizard.step.sample": "Sample",
  "wizard.step.pickup": "Ophalen",
  "wizard.step.destination": "Bestemming",

  // Hero headers
  "wizard.hero.dryIceConfig": "Droogijs Configuratie",
  "wizard.hero.dryIceConfigSub": "Selecteer de hoeveelheid en vorm van droogijs",
  "wizard.hero.whereToDeliver": "Waar bezorgen we?",
  "wizard.hero.whereToDeliverSub": "Vul het bezorgadres in voor je droogijs levering",
  "wizard.hero.deliveryMoment": "Bezorgmoment",
  "wizard.hero.deliveryMomentSub": "Kies het gewenste bezorgmoment voor je droogijs",
  "wizard.hero.checkConfirm": "Controleer & Bevestig",
  "wizard.hero.checkConfirmSub": "Controleer je bestelling voordat je bevestigt",
  "wizard.hero.paymentMethod": "Betaalmethode",
  "wizard.hero.paymentMethodSub": "Kies hoe je wilt betalen voor je bestelling",
  "wizard.hero.productInfo": "Product Informatie",
  "wizard.hero.productInfoSub": "Beschrijf je product, temperatuur en speciale vereisten",
  "wizard.hero.pickupLocation": "Ophaallocatie",
  "wizard.hero.pickupLocationSub": "Waar wordt de zending opgehaald?",
  "wizard.hero.pickupMoment": "Ophaalmoment",
  "wizard.hero.pickupMomentSub": "Plan wanneer de koerier je zending komt ophalen",
  "wizard.hero.deliveryAddress": "Bezorgadres",
  "wizard.hero.deliveryAddressSub": "Waar moet je zending naartoe?",
  "wizard.hero.transportRoute": "Transport Route",
  "wizard.hero.transportRouteSub": "Plan de route en tussenstops voor je zending",

  // Temperature options
  "wizard.temp.cooled": "Gekoeld",
  "wizard.temp.cooledDesc": "Farmaceutica & reagentia",
  "wizard.temp.frozen": "Bevroren",
  "wizard.temp.frozenDesc": "Samples & biologisch materiaal",
  "wizard.temp.deepFrozen": "Diepgevroren",
  "wizard.temp.deepFrozenDesc": "Ultra-lage temperatuur opslag",

  // Delivery options
  "wizard.delivery.sameDay": "Same Day",
  "wizard.delivery.sameDayDesc": "Vandaag besteld, vandaag geleverd",
  "wizard.delivery.sameDayDetail": "Levering vóór 22:00",
  "wizard.delivery.nextMorning": "Morgen vóór 12:00",
  "wizard.delivery.nextMorningDesc": "Express ochtendlevering",
  "wizard.delivery.nextMorningDetail": "Gegarandeerd vóór 12:00",
  "wizard.delivery.nextDay": "Volgende werkdag",
  "wizard.delivery.nextDayDesc": "Standaard express levering",
  "wizard.delivery.nextDayDetail": "Levering vóór 18:00",
  "wizard.delivery.economy": "Economisch (2-3 dagen)",
  "wizard.delivery.economyDesc": "Voordeligste optie",
  "wizard.delivery.economyDetail": "Binnen 2-3 werkdagen",

  // Special handling
  "wizard.handling.fragile": "Breekbaar",
  "wizard.handling.fragileDesc": "Extra bescherming tegen schokken",
  "wizard.handling.upright": "Rechtop houden",
  "wizard.handling.uprightDesc": "Niet kantelen tijdens transport",
  "wizard.handling.lightSensitive": "Lichtgevoelig",
  "wizard.handling.lightSensitiveDesc": "Beschermen tegen licht",
  "wizard.handling.hazardous": "Gevaarlijke stof",
  "wizard.handling.hazardousDesc": "UN-classificatie vereist",

  // Address labels
  "wizard.pickupAddress": "Ophaaladres *",
  "wizard.destinationAddress": "Bestemmingsadres *",

  // Pickup tips
  "wizard.prepTips": "Voorbereidingstips",
  "wizard.prepTip1": "Zorg dat het product verpakt en gelabeld klaarstaat",
  "wizard.prepTip2": "Controleer de temperatuur bij overdracht aan de koerier",
  "wizard.prepTip3": "Houd transportdocumenten en CMR-brief gereed",
  "wizard.prepTip4": "GDP-registratie start bij ophaling",

  // Cold chain
  "wizard.coldChain": "Cold Chain Garantie",
  "wizard.coldChainDesc": "Jouw zending wordt gedurende het volledige traject op {temp} gehouden. Bij afwijking ontvang je direct een temperatuuralert en wordt er actie ondernomen.",
  "wizard.coldChain.gdp": "GDP-compliant",
  "wizard.coldChain.monitoring": "Live monitoring",
  "wizard.coldChain.insured": "Verzekerd",

  // Route
  "wizard.route.mapUnavailable": "Kaartpreview niet beschikbaar",
  "wizard.route.ensureCities": "Zorg dat ophaal- en bezorgstad bekend zijn",
  "wizard.route.about": "Over de route",
  "wizard.route.aboutDesc": "De route is automatisch uitgestippeld op basis van je gekozen bezorgsnelheid en locaties. Je kunt tussenstops toevoegen, verwijderen of het transporttype aanpassen.",
  "wizard.route.road": "Wegtransport",
  "wizard.route.roadDesc": "Gekoeld / bevroren",
  "wizard.route.air": "Luchtvracht",
  "wizard.route.airDesc": "Express / intercont.",
  "wizard.route.sea": "Zeevracht",
  "wizard.route.seaDesc": "Reefer containers",
  "wizard.route.stops": "{count} tussenstop(s)",

  // Small export
  "wizard.sample.description": "Sample omschrijving *",
  "wizard.sample.placeholder": "Beschrijf de sample (bijv. farmaceutische samples, bloedmonsters, DNA samples, etc.)",
  "wizard.sample.tempRequired": "Temperatuurvereiste *",

  // Location preview
  "wizard.locationPreview": "Locatiepreview",
  "wizard.locationPreviewHint": "Vul postcode + huisnummer in",

  // Confirm step
  "wizard.confirm.deliveryAddress": "Bezorgadres",
  "wizard.confirm.pickupLocation": "Ophaallocatie",
  "wizard.confirm.deliveryMoment": "Bezorgmoment",
  "wizard.confirm.subscription": "Abonnement",
  "wizard.confirm.weekly": "Wekelijks",
  "wizard.confirm.biweekly": "Tweewekelijks",
  "wizard.confirm.monthly": "Maandelijks",
  "wizard.confirm.pickupMoment": "Ophaalmoment",
  "wizard.confirm.rush": "Spoed",
  "wizard.confirm.dryIceOrder": "Droogijs bestelling",
  "wizard.confirm.contactPerson": "Contactpersoon",
  "wizard.confirm.contactConfirm": "Deze contactpersoon ontvangt de orderbevestiging en bezorgupdates per e-mail.",
  "wizard.confirm.billingAddress": "Facturatieadres",
  "wizard.confirm.sameAsDelivery": "Gelijk aan bezorgadres",
  "wizard.confirm.differentAddress": "Ander facturatieadres",

  // Pricing
  "wizard.price.overview": "Prijsoverzicht",
  "wizard.price.packaging": "Verpakking",
  "wizard.price.dryIce": "Droogijs",
  "wizard.price.partialFillSurcharge": "Toeslag onvolle doos (+20%)",
  "wizard.price.delivery": "Bezorging",
  "wizard.price.shipping": "Verzending",
  "wizard.price.rush": "Spoed",
  "wizard.price.compliance": "Compliance",
  "wizard.price.intermediateStops": "Tussenstops ({count})",
  "wizard.price.subtotal": "Subtotaal",
  "wizard.price.subtotalExVat": "Subtotaal (excl. BTW)",
  "wizard.price.productDiscount": "Productkorting ({pct}%)",
  "wizard.price.shippingDiscount": "Verzendkorting ({pct}%)",
  "wizard.price.vat": "BTW (21%)",
  "wizard.price.totalInclVat": "Totaal (incl. BTW)",
  "wizard.price.total": "Totaal",
  "wizard.price.toPay": "Te betalen",
  "wizard.price.perDelivery": "Per levering",
  "wizard.price.frequency": "Frequentie",
  "wizard.price.deliveryCostsNext": "+ bezorgkosten in volgende stap",
  "wizard.price.sublimation": "Sublimatie (+10%)",
  "wizard.price.included": "Inbegrepen",
  "wizard.price.temperature": "Temperatuur",
  "wizard.price.filled": "gevuld",

  // Payment
  "wizard.payment.ideal": "iDEAL",
  "wizard.payment.idealDesc": "Direct betalen via je bank",
  "wizard.payment.idealSecure": "Veilig & direct verwerkt",
  "wizard.payment.invoice": "Op factuur",
  "wizard.payment.invoiceDesc": "Betaal binnen {days} dagen",
  "wizard.payment.invoiceVisible": "Factuur zichtbaar in je portaal",
  "wizard.payment.secureRedirect": "Je wordt doorgestuurd naar een beveiligde betaalpagina. Na succesvolle betaling kom je automatisch terug.",

  // Agree
  "wizard.agree": "Ik ga akkoord met de bestelling en de bijbehorende voorwaarden",

  // Dialog: save address
  "wizard.saveAddress": "Adres opslaan?",
  "wizard.saveAddressDesc": "Wil je dit bezorgadres opslaan in je adresboek zodat je het later opnieuw kunt gebruiken?",
  "wizard.saveAddressNo": "Nee, ga verder",
  "wizard.saveAddressYes": "Ja, opslaan",

  // Dialog: leave wizard
  "wizard.leaveTitle": "Bestelling verlaten?",
  "wizard.leaveDesc": "Je hebt een bestelling in bewerking. Wil je deze als concept opslaan zodat je later verder kunt?",
  "wizard.leaveCancel": "Annuleren",
  "wizard.leaveDiscard": "Niet opslaan",
  "wizard.leaveSave": "Opslaan als concept",

  // Confirm button
  "wizard.confirm.button": "Bevestigen",

  // Sidebar
  "wizard.sidebar.dryIceStep": "1. Droogijs",
  "wizard.sidebar.deliveryStep": "2. Bezorging",
  "wizard.sidebar.deliveryNotSet": "Nog niet gekozen",
  "wizard.sidebar.subscription": "Abonnement",

  // ShipmentTypeSelector
  "shipment.orderDryIce": "Bestel nu vers Droogijs",
  "shipment.orderDryIceDesc": "Bestel een EPS isolatiebox gevuld met droogijs voor eigen gebruik",
  "shipment.orderDryIceHint": "Populair bij horeca & catering",
  "shipment.orderDryIceFeature1": "Keuze uit droogijsvorm",
  "shipment.orderDryIceFeature2": "5kg, 12kg, 15kg, 20kg of 25kg",
  "shipment.orderDryIceFeature3": "Bezorging op je adres",
  "shipment.productShipment": "Productverzending",
  "shipment.productShipmentDesc": "Voor het verzenden van vlees, vis en andere versproducten met droogijscontainer",
  "shipment.productShipmentHint": "Voor exporteurs & distributeurs",
  "shipment.productShipmentFeature1": "Grote droogijscontainer",
  "shipment.productShipmentFeature2": "Productomschrijving",
  "shipment.productShipmentFeature3": "Internationale verzending",
  "shipment.comingSoon": "Binnenkort beschikbaar",
  "shipment.smallQuantities": "Kleine hoeveelheden",
  "shipment.smallQuantitiesDesc": "EPS isolatiebox gevuld met droogijs | perfect voor horeca, catering en dagelijks gebruik",
  "shipment.largeQuantities": "Grote hoeveelheden",
  "shipment.largeQuantitiesDesc": "Droogijs in bulk vanaf 150kg | geschikt voor pharma, food productie en industrieel gebruik",
  "shipment.smallFeature1": "Lichtgewicht EPS isolatiebox",
  "shipment.smallFeature2": "Pellets, schijven of blokken",
  "shipment.smallFeature3": "Ideaal voor horeca & catering",
  "shipment.largeFeature1": "Langere houdbaarheid",
  "shipment.largeFeature2": "Pharma, food & productie",
  "shipment.largeFeature3": "Spoedlevering mogelijk",

  // DryIceOrderBuilder
  "dryice.form": "Droogijsvorm",
  "dryice.formDesc": "Kies de vorm van het droogijs voor je zending.",
  "dryice.pellets": "Pellets",
  "dryice.pelletsDesc": "Korrels (10mm)",
  "dryice.comingSoon": "Binnenkort",
  "dryice.chooseQuantity": "Kies de hoeveelheid, combineren mogelijk",
  "dryice.epsBox": "EPS Box",
  "dryice.epsBoxDesc": "Geïsoleerde EPS doos, ideaal voor kleinere hoeveelheden droogijs.",
  "dryice.container": "Droogijs Container",
  "dryice.containerDesc": "Grote geïsoleerde containers voor bulk droogijs leveringen.",
  "dryice.calculate": "Bereken",
  "dryice.adviseContainers": "Voor {kg} kg adviseren wij containers",
  "dryice.adviseEps": "Voor {kg} kg adviseren wij EPS dozen",
  "dryice.adviseContainerReason": "Vanaf 150 kg is een container voordeliger en efficiënter.",
  "dryice.adviseEpsReason": "Onder 150 kg zijn EPS dozen voordeliger.",
  "dryice.useContainers": "Containers gebruiken",
  "dryice.useEps": "EPS dozen gebruiken",
  "dryice.stillEps": "Toch EPS",
  "dryice.stillContainers": "Toch containers",
  "dryice.optimizePacking": "Verpakking optimaliseren",
  "dryice.filledPercent": "{pct}% gevuld",
  "dryice.filledWith": "Gevuld met {fill} kg van {cap} kg · Onvolle doos toeslag: +€{amount}",
  "dryice.fillUpTo": "Vul aan tot {kg} kg en bespaar €{amount}",
  "dryice.fillUpExtra": "+{kg} kg extra droogijs · geen toeslag voor volle doos",
  "dryice.recurringOrder": "Terugkerende bestelling",
  "dryice.repeatOrder": "Herhaalbestelling",
  "dryice.repeatOrderDesc": "Ontvang automatisch droogijs op een vast schema",
  "dryice.weekly": "Wekelijks",
  "dryice.weeklyDesc": "Elke week",
  "dryice.biweekly": "Tweewekelijks",
  "dryice.biweeklyDesc": "Om de 2 weken",
  "dryice.monthly": "Maandelijks",
  "dryice.monthlyDesc": "Elke maand",
  "dryice.autoScheduleNote": "De volgende levering wordt automatisch gepland op basis van de datum van je huidige levering.",
  "dryice.smallShipment": "Kleine zending",
  "dryice.standard": "Standaard",
  "dryice.medium": "Medium",
  "dryice.large": "Groot",
  "dryice.extraLarge": "Extra groot",
  "dryice.compact": "Compact",

  // AddressForm
  "address.company": "Bedrijf *",
  "address.postalCode": "Postcode *",
  "address.houseNumber": "Huisnummer *",
  "address.street": "Straat",
  "address.streetAutoFill": "Wordt automatisch ingevuld",
  "address.addition": "Toevoeging",
  "address.city": "Stad *",
  "address.country": "Land *",
  "address.contactPerson": "Contactpersoon",
  "address.pickupLocation": "ophaalocatie",
  "address.destinationLocation": "bestemmingslocatie",
  "address.firstName": "Voornaam",
  "address.lastName": "Achternaam",
  "address.email": "E-mail",
  "address.phone": "Telefoon",
  "address.saveToAddressBook": "Sla op in adresboek",
  "address.pickupDate": "Ophaaldatum",
  "address.deliveryDate": "Leveringsdatum",
  "address.selectDate": "Selecteer datum",
  "address.viewStreetView": "Bekijk in Street View",
  "address.locationPreview": "Locatiepreview",
  "address.fillPostcode": "Vul postcode + huisnummer in",

  // Billing section
  "billing.title": "Facturatieadres",
  "billing.sameAsDelivery": "Gelijk aan bezorgadres",
  "billing.companyName": "Bedrijfsnaam *",
  "billing.streetAndNumber": "Straat + huisnr *",
  "billing.streetName": "Straatnaam",
  "billing.number": "Nr.",
  "billing.postalCode": "Postcode *",
  "billing.city": "Plaats *",

  // Confirm step extras
  "confirm.notSelected": "Niet geselecteerd",
  "confirm.recurringOrder": "Terugkerende bestelling",
  "confirm.subscription": "Abonnement",
  "confirm.singleOrder": "Eenmalige bestelling",
  "confirm.pickupMoment": "Ophaalmoment",
  "confirm.deliveryMoment": "Bezorgmoment",
  "confirm.deliveryAddress": "Bezorgadres",

  // Sidebar
  "sidebar.priceOverview": "Prijsoverzicht",
  "sidebar.noItemsSelected": "Nog geen items geselecteerd",
  "sidebar.subtotalDryIce": "Subtotaal droogijs",
  "sidebar.deliveryAddress": "2. Bezorgadres",
  "sidebar.notFilled": "Nog niet ingevuld",
  "sidebar.deliveryMoment": "3. Bezorgmoment",
  "sidebar.notChosen": "Nog niet gekozen",
  "sidebar.delivery": "Bezorging",
  "sidebar.subtotal": "Subtotaal",
  "sidebar.total": "Totaal",
  "sidebar.exclVat": "(excl. BTW)",
  "sidebar.packagingCount": "Verpakking ({count}×)",
  "sidebar.partialSurcharge": "Toeslag onvol (+20%)",

  // OrderReviewDialog
  "review.dialogTitle": "Hoe was je ervaring?",
  "review.description": "Beoordeel bestelling {orderNumber}. Je feedback helpt ons verbeteren.",
  "review.alreadyReviewed": "Je hebt deze bestelling al beoordeeld.",
  "review.reviewTitle": "Beoordeling",
  "review.placeholder": "Optioneel: licht je score toe...",
  "review.cancel": "Annuleren",
  "review.dialogSubmit": "Versturen",
  "review.close": "Sluiten",
  "review.thankYou": "Bedankt voor je beoordeling!",
  "review.error": "Kon beoordeling niet opslaan",

  // Feedback dialog
  "feedback.trigger": "Feedback",
  "feedback.dialogTitle": "Feedback geven",
  "feedback.dialogDescription": "Help ons het platform te verbeteren. Deel je suggesties, meld een bug of vraag een nieuwe functie aan.",
  "feedback.typeLabel": "Type",
  "feedback.typeBug": "Bug melden",
  "feedback.typeFeature": "Functie aanvragen",
  "feedback.typeImprovement": "Verbetering",
  "feedback.typeGeneral": "Algemeen",
  "feedback.messageLabel": "Bericht",
  "feedback.messagePlaceholder": "Beschrijf je feedback...",
  "feedback.cancel": "Annuleren",
  "feedback.submit": "Versturen",
  "feedback.successTitle": "Feedback verstuurd",
  "feedback.successDescription": "Bedankt voor je feedback! We bekijken het zo snel mogelijk.",
  "feedback.errorTitle": "Versturen mislukt",
  "feedback.portalUser": "Portaalgebruiker",

  // Portal Orders page - hardcoded strings
  "portal.orders.title": "Mijn Bestellingen",
  "portal.orders.subtitle": "Bekijk de status van je bestellingen",
  "portal.orders.newOrder": "Nieuwe Bestelling",
  "portal.orders.ordersTab": "Bestellingen",
  "portal.orders.trackTab": "Track & Trace",
  "portal.orders.total": "totaal",
  "portal.orders.ordersCount": "Bestellingen",
  "portal.orders.searchPlaceholder": "Zoek op ordernummer, bedrijf...",
  "portal.orders.allStatuses": "Alle statussen",
  "portal.orders.filterStatus": "Filter op status",
  "portal.orders.allTypes": "Alle types",
  "portal.orders.typeShipment": "Type verzending",
  "portal.orders.epsType": "EPS Droogijs",
  "portal.orders.containerType": "Container Droogijs",
  "portal.orders.noOrders": "Geen bestellingen",
  "portal.orders.noOrdersDesc": "Je hebt nog geen bestellingen geplaatst.",
  "portal.orders.continue": "Verder",
  "portal.orders.deleteConfirm": "Weet je zeker dat je dit concept wilt verwijderen?",
  "portal.orders.copy": "Kopieer",
  "portal.orders.view": "Bekijk",
  "portal.orders.review": "Beoordeel",
  "portal.orders.orderNumber": "Ordernummer",
  "portal.orders.type": "Type",
  "portal.orders.destination": "Bestemming",
  "portal.orders.date": "Datum",
  "portal.orders.price": "Prijs",
  "portal.orders.actions": "Acties",
  "portal.orders.copyOrder": "Kopieer bestelling",
  "portal.orders.viewDetails": "Bekijk details",

  // Portal Orders detail sheet
  "portal.orderDetail.productDetails": "Product Details",
  "portal.orderDetail.dryIce": "Droogijs",
  "portal.orderDetail.packaging": "Verpakking",
  "portal.orderDetail.temperature": "Temperatuur",
  "portal.orderDetail.description": "Omschrijving",
  "portal.orderDetail.destination": "Bestemming",
  "portal.orderDetail.progress": "Voortgang",
  "portal.orderDetail.trackShipment": "Volg je zending via Track & Trace",
  "portal.orderDetail.priceOverview": "Prijsoverzicht",
  "portal.orderDetail.inclPackaging": "incl. EPS Box",
  "portal.orderDetail.shipping": "Verzending",
  "portal.orderDetail.subtotalExVat": "Subtotaal (excl. BTW)",
  "portal.orderDetail.vat": "BTW (21%)",
  "portal.orderDetail.totalInclVat": "Totaal (incl. BTW)",
  "portal.orderDetail.noPrice": "Geen prijs beschikbaar",
  "portal.orderDetail.yourReview": "Jouw beoordeling",
  "portal.orderDetail.reviewOrder": "Beoordeel deze bestelling",
  "portal.orderDetail.orderedOn": "Besteld op",
  "portal.orderDetail.orderCancelled": "Bestelling geannuleerd",
  "portal.orderDetail.order": "Bestelling",

  // Portal Orders track tab
  "portal.track.followShipment": "Zending volgen",
  "portal.track.enterCode": "Voer je ordernummer of track & trace code in",
  "portal.track.exampleCode": "Bijv. ORD-240001 of 3SXXXX0000000",
  "portal.track.search": "Zoeken",
  "portal.track.searching": "Zending opzoeken...",
  "portal.track.notFound": "Geen zending gevonden",
  "portal.track.checkCode": "Controleer je code en probeer opnieuw.",
  "portal.track.orderNumber": "Ordernummer",
  "portal.track.shipmentDetails": "Zendingsdetails",
  "portal.track.created": "Aangemaakt",
  "portal.track.delivery": "Levering",
  "portal.track.carrier": "Vervoerder",
  "portal.track.trackingCode": "Tracking code",
  "portal.track.dryIce": "Droogijs",
  "portal.track.packaging": "Verpakking",
  "portal.track.destination": "Bestemming",
  "portal.track.attn": "t.a.v.",
  "portal.track.tip": "Tip: Deel de",
  "portal.track.tipPage": "Track & Trace pagina",
  "portal.track.tipEnd": "met je ontvanger, zodat zij zonder inloggen de status van de zending kunnen volgen.",

  // Portal Orders status labels
  "portal.status.draft": "Concept",
  "portal.status.submitted": "Ingediend",
  "portal.status.confirmed": "Bevestigd",
  "portal.status.in_production": "In productie",
  "portal.status.shipped": "Onderweg",
  "portal.status.completed": "Afgeleverd",
  "portal.status.cancelled": "Geannuleerd",
  "portal.status.received": "Ontvangen",
  "portal.status.production": "Productie",

  // Portal Orders type labels
  "portal.type.eps-dryice": "EPS Droogijs",
  "portal.type.large-export": "Container Droogijs",
  "portal.type.small-export": "Container Droogijs",

  // Portal Invoices page
  "portal.invoices.title": "Facturen",
  "portal.invoices.subtitle": "Bekijk en download je facturen en betalingsgeschiedenis.",
  "portal.invoices.paid": "Betaald",
  "portal.invoices.outstanding": "Openstaand",
  "portal.invoices.total": "Totaal",
  "portal.invoices.history": "Factuurhistorie",
  "portal.invoices.searchPlaceholder": "Zoek op factuurnummer, bedrijf...",
  "portal.invoices.allStatuses": "Alle statussen",
  "portal.invoices.filterStatus": "Filter op status",
  "portal.invoices.statusOpen": "Open",
  "portal.invoices.statusPaid": "Betaald",
  "portal.invoices.statusOverdue": "Verlopen",
  "portal.invoices.invoiceNumber": "Factuurnummer",
  "portal.invoices.date": "Datum",
  "portal.invoices.destination": "Bestemming",
  "portal.invoices.amount": "Bedrag",
  "portal.invoices.status": "Status",
  "portal.invoices.openSince": "Open sinds",
  "portal.invoices.actions": "Acties",
  "portal.invoices.viewInvoice": "Factuur bekijken",
  "portal.invoices.downloadPdf": "Download PDF",
  "portal.invoices.view": "Bekijken",
  "portal.invoices.pay": "Betalen",
  "portal.invoices.noInvoices": "Geen facturen gevonden",
  "portal.invoices.adjustSearch": "Pas je zoekopdracht aan.",
  "portal.invoices.noInvoicesYet": "Je hebt nog geen bestellingen met facturen. Plaats je eerste bestelling om te beginnen.",
  "portal.invoices.newOrder": "Nieuwe bestelling",
  "portal.invoices.today": "Vandaag",
  "portal.invoices.day": "dag",
  "portal.invoices.days": "dagen",
  "portal.invoices.paidOn": "Betaald op",
  "portal.invoices.open": "Open",
  "portal.invoices.downloaded": "Factuur gedownload",
  "portal.invoices.downloadedDesc": "Factuur {0} is gedownload als PDF.",
  "portal.invoices.downloadFailed": "Download mislukt",
  "portal.invoices.downloadFailedDesc": "Er ging iets mis bij het downloaden van de factuur.",
  "portal.invoices.paymentSuccess": "Betaling succesvol",
  "portal.invoices.paymentSuccessDesc": "Factuur {0} is betaald.",
  "portal.invoices.paymentFailed": "Betaling mislukt",
  "portal.invoices.payTitle": "Factuur Betalen",
  "portal.invoices.payDescription": "Kies een betaalmethode om deze factuur te voldoen.",
  "portal.invoices.invoiceNum": "Factuurnummer",
  "portal.invoices.amountExVat": "Bedrag (excl. BTW)",
  "portal.invoices.vat": "BTW",
  "portal.invoices.totalAmount": "Totaal",
  "portal.invoices.bankTransfer": "Overmaken per bank",
  "portal.invoices.accountHolder": "Rekeninghouder",
  "portal.invoices.iban": "IBAN",
  "portal.invoices.bank": "Bank",
  "portal.invoices.reference": "Omschrijving",
  "portal.invoices.amountLabel": "Bedrag",
  "portal.invoices.bankInfo": "Maak het bedrag over naar bovenstaand rekeningnummer onder vermelding van het factuurnummer. Na ontvangst wordt de factuur automatisch op betaald gezet.",
  "portal.invoices.or": "OF",
  "portal.invoices.onlinePayment": "Online betalen",
  "portal.invoices.payOnline": "Online betalen via iDEAL",
  "portal.invoices.close": "Sluiten",
  "portal.invoices.copied": "Gekopieerd",
  "portal.invoices.ibanCopied": "IBAN is gekopieerd naar klembord.",
  "portal.invoices.invoiceCopied": "Factuurnummer is gekopieerd naar klembord.",
  "portal.invoices.noCheckoutUrl": "Geen checkout URL ontvangen",
  "portal.invoices.error": "Fout",
  "portal.invoices.paymentStartFailed": "Betaling kon niet worden gestart.",
  "portal.invoices.invoice": "Factuur",
  "portal.invoices.dryIceOrder": "Droogijs bestelling",

  // Order Success page
  "success.thankYou": "Bedankt voor je {type}!",
  "success.order": "bestelling",
  "success.shipment": "zending",
  "success.descOrder": "Je droogijs bestelling is succesvol geplaatst. We gaan direct voor je aan de slag. Je ontvangt een bevestiging per e-mail.",
  "success.descShipment": "Je zending is succesvol geplaatst. We gaan direct voor je aan de slag. Je ontvangt een bevestiging per e-mail.",
  "success.orderLabel": "Bestelling",
  "success.type": "Type",
  "success.dryIceOrder": "Droogijs bestelling",
  "success.productShipment": "Productverzending",
  "success.sampleShipment": "Sample verzending",
  "success.deliveryAddress": "Bezorgadres",
  "success.destination": "Bestemming",
  "success.carrier": "Vervoerder",
  "success.subscription": "Abonnement",
  "success.weekly": "Wekelijks",
  "success.biweekly": "Tweewekelijks",
  "success.monthly": "Maandelijks",
  "success.periodic": "Periodiek",
  "success.subscriptionCreated": "Er is een planning aangemaakt voor deze terugkerende bestelling",
  "success.totalAmount": "Totaalbedrag",
  "success.recurringCreated": "Periodieke bestelling aangemaakt",
  "success.recurringDesc": "Deze bestelling wordt automatisch {frequency} herhaald. Je kunt je planning beheren via het menu.",
  "success.viewOrder": "Bekijk bestelling",
  "success.newOrder": "Nieuwe bestelling",
  "success.reference": "Referentienummer: {0} · Een bevestiging is verstuurd naar je e-mailadres",

  // Address form dialog
  "addressForm.editTitle": "Adres bewerken",
  "addressForm.addTitle": "Nieuw adres toevoegen",
  "addressForm.label": "Label",
  "addressForm.labelPlaceholder": "bijv. Hoofdkantoor",
  "addressForm.companyName": "Bedrijfsnaam *",
  "addressForm.street": "Straat *",
  "addressForm.streetPlaceholder": "Straatnaam",
  "addressForm.houseNumber": "Nr. *",
  "addressForm.postalCode": "Postcode *",
  "addressForm.city": "Stad *",
  "addressForm.country": "Land *",
  "addressForm.contactName": "T.n.v.",
  "addressForm.contactPlaceholder": "bijv. Jan Jansen",
  "addressForm.defaultAddress": "Standaardadres",
  "addressForm.defaultAddressDesc": "Gebruik dit adres als standaard voor dit type",
  "addressForm.cancel": "Annuleren",
  "addressForm.saving": "Opslaan...",
  "addressForm.update": "Bijwerken",
  "addressForm.add": "Toevoegen",
  "addressForm.companyRequired": "Bedrijfsnaam is verplicht",
  "addressForm.streetRequired": "Straat is verplicht",
  "addressForm.houseNumberRequired": "Huisnummer is verplicht",
  "addressForm.cityRequired": "Stad is verplicht",
  "addressForm.postalCodeRequired": "Postcode is verplicht",
  "addressForm.countryRequired": "Land is verplicht",

  // Billing address book picker
  "billingPicker.chooseFromBook": "Kies uit adresboek",
  "billingPicker.addressBook": "Adresboek",
  "billingPicker.noAddresses": "Geen adressen opgeslagen",

  // Dry ice amount selector
  "dryiceAmount.title": "Hoeveelheid droogijs",
  "dryiceAmount.small": "Kleine zending",
  "dryiceAmount.standard": "Standaard",
  "dryiceAmount.medium": "Medium",
  "dryiceAmount.large": "Groot",
  "dryiceAmount.extraLarge": "Extra groot",
  "dryiceAmount.container": "Container",

  // NewShipment - temperature options
  "temp.chilled": "Gekoeld",
  "temp.chilledDesc": "Farmaceutica & reagentia",
  "temp.frozen": "Bevroren",
  "temp.frozenDesc": "Samples & biologisch materiaal",
  "temp.deepFrozen": "Diepgevroren",
  "temp.deepFrozenDesc": "Ultra-lage temperatuur opslag",

  // NewShipment - delivery options
  "delivery.sameDay": "Same Day",
  "delivery.sameDayDesc": "Vandaag besteld, vandaag geleverd",
  "delivery.sameDayDetail": "Levering vóór 22:00",
  "delivery.nextMorning": "Morgen vóór 12:00",
  "delivery.nextMorningDesc": "Express ochtendlevering",
  "delivery.nextMorningDetail": "Gegarandeerd vóór 12:00",
  "delivery.nextDay": "Volgende werkdag",
  "delivery.nextDayDesc": "Standaard express levering",
  "delivery.nextDayDetail": "Levering vóór 18:00",
  "delivery.economy": "Economisch (2-3 dagen)",
  "delivery.economyDesc": "Voordeligste optie",
  "delivery.economyDetail": "Binnen 2-3 werkdagen",

  // NewShipment - special handling
  "handling.fragile": "Breekbaar",
  "handling.fragileDesc": "Extra bescherming tegen schokken",
  "handling.upright": "Rechtop houden",
  "handling.uprightDesc": "Niet kantelen tijdens transport",
  "handling.lightSensitive": "Lichtgevoelig",
  "handling.lightSensitiveDesc": "Beschermen tegen licht",
  "handling.hazardous": "Gevaarlijke stof",
  "handling.hazardousDesc": "UN-classificatie vereist",

  // Dashboard additional
  "dashboard.overview": "Hier is een overzicht van je bestellingen.",
  "dashboard.noPendingInvoices": "Geen openstaande facturen",
  "dashboard.orderNumber": "Ordernummer",
  "dashboard.epsDryIce": "EPS Droogijs",

  // Additional invoice keys
  "invoices.invoice": "Factuur",
  "invoices.noCheckoutUrl": "Geen checkout URL ontvangen",
  "invoices.errorTitle": "Fout",
  "invoices.paymentError": "Betaling kon niet worden gestart.",
  "invoices.dryIceOrder": "Droogijs bestelling",
  "invoices.newOrder": "Nieuwe bestelling",
  "invoices.exclVatLabel": "Bedrag (excl. BTW)",
  "invoices.totalLabel": "Totaal",
  "invoices.vatPercent": "BTW",

  // Additional order keys
  "orders.received": "Ontvangen",
  "orders.totalLabel": "totaal",
  "orders.production": "Productie",
  "orders.myOrders": "Mijn Bestellingen",
  "orders.viewStatus": "Bekijk de status van je bestellingen",
  "orders.attn": "t.a.v.",
  "orders.shipmentDetails": "Zendingsdetails",
  "orders.deliveryLabel": "Levering",
  "orders.trackSearch": "Zoeken",
  "orders.searching": "Zending opzoeken...",
  "orders.noShipmentFound": "Geen zending gevonden",

  // Additional settings keys
  "settings.companyNamePlaceholder": "Uw bedrijfsnaam",
  "settings.billingEmailPlaceholder": "facturatie@bedrijf.nl",
  "settings.addressPlaceholder": "Straatnaam",
  "settings.netherlands": "Nederland",
  "settings.belgium": "België",
  "settings.luxembourg": "Luxemburg",
  "settings.germany": "Duitsland",
  "settings.france": "Frankrijk",

  // Help page
  "help.searchPlaceholder": "Doorzoek het helpcentrum...",
  "help.liveChat": "Live Chat",
  "help.liveChatDesc": "Chat direct met ons supportteam",
  "help.startChat": "Start Chat",
  "help.phoneLabel": "Telefoon",
  "help.phoneHours": "Ma-Vr 9:00 - 18:00",
  "help.emailLabel": "E-mail",
  "help.emailResponseTime": "Reactie binnen 24 uur",
  "help.sendEmail": "E-mail Sturen",
  "help.faqTitle": "Veelgestelde Vragen",
  "help.emergencyTitle": "24/7 Noodondersteuning",
  "help.emergencyDesc": "Dringende problemen met een lopende bestelling? Ons noodteam is 24/7 bereikbaar.",
  "help.callEmergency": "Bel Noodlijn",
  "help.faq1Q": "Hoe plaats ik een nieuwe bestelling?",
  "help.faq1A": "Ga naar 'Nieuwe Bestelling' in het menu, kies het type droogijs (EPS Box of Container), selecteer de gewenste hoeveelheid en bezorgdatum, en rond de bestelling af. Je ontvangt een bevestiging per e-mail.",
  "help.faq2Q": "Welke producten kan ik bestellen?",
  "help.faq2A": "Wij leveren droogijs in twee vormen: EPS Droogijs (in geïsoleerde EPS boxen) en Container Droogijs (in grotere containers). Je kiest het type dat past bij jouw toepassing.",
  "help.faq3Q": "Hoe werkt het droogijs?",
  "help.faq3A": "Droogijs is bevroren CO₂ met een temperatuur van -78,5°C. Het sublimeert direct van vaste stof naar gas, waardoor het ideaal is voor koeling zonder vochtresten. Wij leveren het in pellets (korrels) of blokken.",
  "help.faq4Q": "Hoe wordt mijn bestelling bezorgd?",
  "help.faq4A": "Alle bestellingen worden bezorgd via onze vaste transportpartner. Je kunt bij het bestellen een gewenste bezorgdatum kiezen (minimaal 3 werkdagen vooruit). De verzendkosten zijn €22,50 per pakket.",
  "help.faq5Q": "Kan ik mijn bestelling wijzigen of annuleren?",
  "help.faq5A": "Neem zo snel mogelijk contact met ons op als je een bestelling wilt wijzigen of annuleren. Via de Help-pagina kun je ons bereiken per telefoon, e-mail of livechat.",
  "help.faq6Q": "Hoe ontvang ik mijn facturen?",
  "help.faq6A": "Facturen zijn beschikbaar in je dashboard onder 'Facturen'. Je kunt ze bekijken en downloaden als PDF.",
  "help.faq7Q": "Wat is een abonnement en wat zijn de voordelen?",
  "help.faq7A": "Met een abonnement ontvang je automatisch droogijs op vaste momenten met korting. Hoe meer bestellingen in je abonnement, hoe hoger de korting. Ideaal voor bedrijven met regelmatig droogijsverbruik.",
  "help.faq8Q": "Wat zijn de levertijden?",
  "help.faq8A": "De standaard levertijd is minimaal 3 werkdagen na het plaatsen van je bestelling. Bij abonnementen wordt de levering automatisch ingepland op de door jou gekozen dag en frequentie.",

  // Address book page
  "addressBook.title": "Adresboek",
  "addressBook.subtitle": "Beheer je opgeslagen bestemmingsadressen",
  "addressBook.newAddress": "Nieuw adres",
  "addressBook.noAddresses": "Geen adressen",
  "addressBook.noAddressesDesc": "Je hebt nog geen adressen opgeslagen.",
  "addressBook.addFirst": "Eerste adres toevoegen",
  "addressBook.deleteTitle": "Adres verwijderen?",
  "addressBook.deleteDesc": "Weet je zeker dat je dit adres wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
  "addressBook.deleting": "Verwijderen...",
  "addressBook.deliveryAddress": "Bezorgadres",
  "addressBook.default": "Standaard",

  // Marketing - Exit Intent Popup
  "exitPopup.title": "Wacht even!",
  "exitPopup.desc": "Vraag vrijblijvend een offerte aan op maat en ontvang persoonlijk advies voor uw droogijsbehoefte.",
  "exitPopup.cta": "Gratis offerte aanvragen",
  "exitPopup.dismiss": "Nee bedankt",

  // Marketing - Mobile Sticky Bar
  "mobileCta.title": "Droogijs bestellen?",
  "mobileCta.subtitle": "Vandaag besteld, morgen geleverd",
  "mobileCta.order": "Bestellen",

  // Marketing - Customer Stories
  "stories.title": "Wat onze klanten zeggen",
  "stories.subtitle": "Bedrijven in heel Nederland vertrouwen op Dutch DryIce voor hun droogijslevering.",
  "stories.name1": "Mark de Vries",
  "stories.role1": "Operationeel Manager, Restaurant De Kaai",
  "stories.quote1": "Sinds we zijn overgestapt naar Dutch DryIce worden onze catering-bestellingen altijd perfect gekoeld afgeleverd. De kwaliteit is constant en de levering stipt op tijd.",
  "stories.name2": "Sandra Bakker",
  "stories.role2": "Logistiek Coördinator, PharmaCold B.V.",
  "stories.quote2": "Voor ons farmaceutisch transport is betrouwbare koeling essentieel. Dutch DryIce levert altijd de juiste hoeveelheid op het juiste moment, met alle certificeringen.",
  "stories.name3": "Peter Jansen",
  "stories.role3": "Eigenaar, CleanTech Solutions",
  "stories.quote3": "We gebruiken droogijs voor industriële reiniging en zijn zeer tevreden over de constante kwaliteit en snelle levering. Het bestelproces is eenvoudig en overzichtelijk.",

  // Marketing - Newsletter
  "newsletter.title": "Blijf op de hoogte",
  "newsletter.subtitle": "Ontvang onze droogijs-gids en blijf op de hoogte van aanbiedingen, tips en nieuws.",
  "newsletter.placeholder": "Uw e-mailadres",
  "newsletter.cta": "Aanmelden",
  "newsletter.privacy": "We respecteren uw privacy. U kunt zich altijd uitschrijven.",
  "newsletter.successTitle": "Aangemeld!",
  "newsletter.successDesc": "U ontvangt binnenkort onze eerste nieuwsbrief.",

  // Marketing - Urgency Banner
  "urgency.orderBefore": "Bestel voor",
  "urgency.deliveryTomorrow": "morgen geleverd!",
  "urgency.timeLeft": "Nog {hours}u {minutes}m",
  "urgency.deliveryRate": "NEN-gecertificeerd droogijs",
  "urgency.certified": "NEN-gecertificeerd droogijs",
  "urgency.nextDay": "Volgende dag levering door heel Nederland",
  "urgency.freshProduced": "Vers geproduceerd op bestelling",
  "urgency.available247": "24/7 bereikbaar voor spoedorders",

  // Quote Request Page
  "quote.badge": "Zakelijke klanten",
  "quote.title": "Offerte op maat aanvragen",
  "quote.subtitle": "Ontvang een persoonlijke offerte afgestemd op uw droogijsbehoefte. Wij nemen binnen 24 uur contact met u op.",
  "quote.labelName": "Naam",
  "quote.labelCompany": "Bedrijfsnaam",
  "quote.labelEmail": "E-mailadres",
  "quote.labelPhone": "Telefoonnummer",
  "quote.labelSector": "Branche",
  "quote.selectSector": "Selecteer uw branche",
  "quote.sectorHoreca": "Horeca & Catering",
  "quote.sectorPharma": "Medisch & Farmaceutisch",
  "quote.sectorFood": "Voedselindustrie",
  "quote.sectorTransport": "Transport & Logistiek",
  "quote.sectorCleaning": "Industrieel reinigen",
  "quote.sectorEvents": "Evenementen",
  "quote.sectorOther": "Anders",
  "quote.labelFrequency": "Gewenste frequentie",
  "quote.selectFrequency": "Selecteer frequentie",
  "quote.freqWeekly": "Wekelijks",
  "quote.freqBiweekly": "Tweewekelijks",
  "quote.freqMonthly": "Maandelijks",
  "quote.freqIncidental": "Incidenteel",
  "quote.labelVolume": "Geschat volume per levering",
  "quote.placeholderVolume": "Bijv. 150 kg per week",
  "quote.labelMessage": "Aanvullende informatie",
  "quote.placeholderMessage": "Vertel ons over uw specifieke wensen...",
  "quote.sending": "Versturen...",
  "quote.sendBtn": "Offerte aanvragen",
  "quote.successTitle": "Offerte aangevraagd",
  "quote.successDesc": "We nemen binnen 24 uur contact met u op.",
  "quote.errorTitle": "Fout",
  "quote.errorDesc": "Er ging iets mis. Probeer het opnieuw.",

  // Kennisbank
  "kb.badge": "Kennisbank",
  "kb.title": "Alles over droogijs",
  "kb.subtitle": "Praktische informatie over toepassingen, veiligheid en opslag van droogijs.",
  "kb.readMore": "Lees meer",
  "kb.ctaTitle": "Nog vragen?",
  "kb.ctaText": "Onze specialisten helpen u graag verder met advies op maat.",
  "kb.ctaBtn": "Neem contact op",
  "kb.art1Title": "Wat is droogijs? Alles over bevroren CO₂",
  "kb.art1Excerpt": "Droogijs is bevroren koolstofdioxide (CO₂) met een temperatuur van -78,5°C. Ontdek hoe het wordt geproduceerd en waarvoor het wordt gebruikt.",
  "kb.art1Date": "15 jan 2025",
  "kb.art2Title": "Veilig werken met droogijs | Richtlijnen en tips",
  "kb.art2Excerpt": "Belangrijke veiligheidsrichtlijnen voor het omgaan met droogijs. PBM's, ventilatie, opslag en eerste hulp bij incidenten.",
  "kb.art2Date": "10 feb 2025",
  "kb.art3Title": "Droogijs opslaan | Tips om sublimatie te minimaliseren",
  "kb.art3Excerpt": "Tips voor het optimaal bewaren van droogijs. De juiste containers, opslagomstandigheden en veelgemaakte fouten.",
  "kb.art3Date": "5 mrt 2025",
  "kb.art4Title": "Droogijs voor voedselvervoer",
  "kb.art4Excerpt": "Hoe droogijs wordt ingezet bij het koelen van maaltijden, vlees, vis en verse producten tijdens transport.",
  "kb.art4Date": "20 mrt 2025",
  "kb.art5Title": "Droogijs levering en logistiek",
  "kb.art5Excerpt": "Hoe onze leveringsketen werkt, van dagelijkse productie tot next-day delivery door heel Nederland.",
  "kb.art5Date": "2 apr 2025",
  "kb.art6Title": "Droogijsstralen voor industriële reiniging",
  "kb.art6Excerpt": "Hoe droogijsstralen werkt als milieuvriendelijk reinigingsmiddel voor machines, mallen en productieapparatuur.",
  "kb.art6Date": "15 apr 2025",
  "kb.art7Title": "Droogijs voor medische en farmaceutische verzendingen",
  "kb.art7Excerpt": "Hoe droogijs wordt ingezet voor het temperatuurgecontroleerd transporteren van vaccins, medicijnen en bloedmonsters.",
  "kb.art7Date": "10 mei 2025",
  "kb.art8Title": "Droogijs vs. gel packs: welk koelmiddel kiest u?",
  "kb.art8Excerpt": "Een uitgebreide vergelijking tussen droogijs en gel packs voor temperatuurgecontroleerd transport.",
  "kb.art8Date": "25 mei 2025",
  "kb.art9Title": "Droogijs voor evenementen en horeca",
  "kb.art9Excerpt": "Spectaculaire rookeffecten bij cocktails, buffetten en evenementen met droogijs.",
  "kb.art9Date": "5 jun 2025",
  "kb.art10Title": "Is droogijs duurzaam? CO₂-voetafdruk en milieu-impact",
  "kb.art10Excerpt": "Een eerlijk antwoord op de vraag of droogijs milieuvriendelijk is en hoe het zich verhoudt tot alternatieven.",
  "kb.art10Date": "20 jun 2025",
  "kb.art11Title": "Hoeveel droogijs heb ik nodig? Berekeningsgids",
  "kb.art11Excerpt": "Praktische richtlijnen en vuistregels om de juiste hoeveelheid droogijs te berekenen.",
  "kb.art11Date": "1 jul 2025",
  "kb.art12Title": "Droogijs verpakken en verzenden: complete handleiding",
  "kb.art12Excerpt": "Stapsgewijze gids voor het correct verpakken, etiketteren en verzenden van producten met droogijs.",
  "kb.art12Date": "15 jul 2025",
  "kb.art13Title": "Droogijs bewaren in de zomer",
  "kb.art13Excerpt": "Hoe bewaar je droogijs effectief in de warme zomermaanden? Praktische tips om sublimatie te vertragen en houdbaarheid te verlengen.",
  "kb.art13Date": "1 aug 2025",
  "kb.art14Title": "Kosten droogijs per kg: complete prijsgids 2025",
  "kb.art14Excerpt": "Wat kost droogijs per kilogram? Compleet overzicht van prijzen, volumekortingen, leveringskosten en bespaartips.",
  "kb.art14Date": "15 aug 2025",
  "kb.art15Title": "Droogijs in het laboratorium",
  "kb.art15Excerpt": "Hoe droogijs wordt ingezet in laboratoria voor het bewaren van monsters, flash-vriezen en cryogene toepassingen.",
  "kb.art15Date": "30 jan 2025",
  "kb.art16Title": "Droogijs voor bloemisterijen",
  "kb.art16Excerpt": "Hoe bloemisten droogijs inzetten om bloemen te koelen tijdens transport en opslag voor maximale versheid.",
  "kb.art16Date": "25 feb 2025",
  "kb.art17Title": "Droogijs in de farmaceutische industrie",
  "kb.art17Excerpt": "De rol van droogijs in de farmaceutische koude keten: van vaccinopslag tot temperatuurgevoelige medicijnen.",
  "kb.art17Date": "1 sep 2025",
  "kb.art18Title": "Droogijs voor wijnkoeling",
  "kb.art18Excerpt": "Hoe u droogijs kunt gebruiken om wijn snel en effectief op de ideale serveertemperatuur te brengen.",
  "kb.art18Date": "15 sep 2025",
  "kb.art19Title": "Droogijs rookeffecten voor theater en entertainment",
  "kb.art19Excerpt": "Professionele rookeffecten creëren met droogijs voor theater, film, evenementen en fotografie.",
  "kb.art19Date": "1 okt 2025",
  "kb.art20Title": "Droogijs voor ijssalons en bevroren desserts",
  "kb.art20Excerpt": "Hoe ijssalons en dessertmakers droogijs gebruiken voor transport, opslag en spectaculaire presentaties.",
  "kb.art20Date": "15 okt 2025",
  "kb.art21Title": "Droogijs in de luchtvaart en luchtvracht",
  "kb.art21Excerpt": "Regelgeving, verpakkingseisen en best practices voor het vervoeren van droogijs per vliegtuig.",
  "kb.art21Date": "1 nov 2025",
  "kb.art22Title": "Droogijs voor Halloween en feesten: rookeffecten veilig toepassen",
  "kb.art22Excerpt": "Spectaculaire maar veilige halloweeneffecten met droogijs: van rookpunches tot mistige decoraties.",
  "kb.art22Date": "15 nov 2025",
  "kb.art23Title": "Droogijs tijdens de feestdagen: kerst en eindejaar toepassingen",
  "kb.art23Excerpt": "Creatief gebruik van droogijs tijdens kerst en oudjaar voor koeling van catering en spectaculaire effecten.",
  "kb.art23Date": "1 dec 2025",
  "kb.art24Title": "Temperatuurregistratie bij droogijstransport: regels en tips",
  "kb.art24Excerpt": "Alles over temperatuurmonitoring en -registratie bij het transport van producten met droogijs.",
  "kb.art24Date": "15 dec 2025",
  "kb.art25Title": "Droogijs in de visverwerking: versheid garanderen",
  "kb.art25Excerpt": "Hoe de visindustrie droogijs inzet voor het koelen en transporteren van verse vis en zeevruchten.",
  "kb.art25Date": "1 jan 2026",
  "kb.art26Title": "Droogijs in de automotive industrie: reiniging en toepassingen",
  "kb.art26Excerpt": "Hoe droogijsstralen wordt ingezet voor het reinigen van auto-onderdelen, mallen en productieapparatuur.",
  "kb.art26Date": "15 jan 2026",
  "kb.art27Title": "Droogijs voor catering en cateringbedrijven",
  "kb.art27Excerpt": "Hoe cateraars droogijs gebruiken voor koeling tijdens transport en het serveren van gerechten.",
  "kb.art27Date": "1 feb 2026",
  "kb.art28Title": "Droogijs pellets vs. blokken: welke vorm kiest u?",
  "kb.art28Excerpt": "Een vergelijking tussen droogijspellets en -blokken: toepassingen, sublimatiesnelheid en kosten.",
  "kb.art28Date": "15 feb 2026",
  "kb.art29Title": "Droogijs voor e-commerce verzendingen: complete gids",
  "kb.art29Excerpt": "Hoe webshops droogijs inzetten voor het verzenden van temperatuurgevoelige producten naar consumenten.",
  "kb.art29Date": "1 mrt 2026",
  "kb.art30Title": "Droogijs opslag tips voor bedrijven: best practices",
  "kb.art30Excerpt": "Professionele opslagtips voor bedrijven die regelmatig droogijs gebruiken: containers, locatie en planning.",
  "kb.art30Date": "15 mrt 2026",
  "kb.art31Title": "Droogijs voor een gender reveal: blauw of roze neveleffect",
  "kb.art31Excerpt": "Maak van de onthulling een magisch moment met droogijs: veiligheidsregels, hoeveelheden en het blauwe of roze neveleffect.",
  "kb.art31Date": "24 sep 2026",

  // A/B Test admin
  "admin.abTestTitle": "A/B Tests",
  "admin.abTestDesc": "Bekijk de resultaten van lopende en afgelopen A/B tests.",

  "kb.readTime": "leestijd",
  "kb.metaTitle": "Kennisbank | Alles over droogijs",
  "kb.metaDesc": "Ontdek alles over droogijs: toepassingen, veiligheid, opslag, voedselvervoer en industriële reiniging. Praktische gidsen van Dutch DryIce.",
  "kb.jsonLdName": "Kennisbank | Dutch DryIce",
  "kb.jsonLdDesc": "Alles over droogijs: toepassingen, veiligheid, opslag en logistiek",

  // Footer additions
  "footer.quoteRequest": "Offerte aanvragen",
  "footer.kennisbank": "Kennisbank",
  "nav.quoteRequest": "Offerte",

  // SEO meta - public pages
  "seo.shop.title": "Bestel droogijs online",
  "seo.shop.desc": "Bestel droogijs in EPS-dozen van 6 tot 25 kg of containers. NEN-gecertificeerd, snelle levering door heel Nederland via DPD.",
  "seo.privacy.title": "Privacybeleid",
  "seo.privacy.desc": "Lees hoe Dutch DryIce uw persoonsgegevens verwerkt, beschermt en hoe wij voldoen aan de AVG-wetgeving voor zakelijke klanten.",
  "seo.terms.title": "Algemene Voorwaarden",
  "seo.terms.desc": "De algemene voorwaarden van Dutch DryIce voor de levering van droogijs, EPS-dozen en containers aan zakelijke afnemers in Nederland.",
  "seo.track.title": "Track & Trace droogijslevering",
  "seo.track.desc": "Volg uw droogijszending in realtime met onze Track & Trace tool. Bekijk de status, geschatte aankomst en bezorgdetails van uw bestelling.",
  "seo.contact.title": "Contact opnemen met Dutch DryIce",
  "seo.contact.desc": "Neem contact op met Dutch DryIce voor vragen over droogijs, leveringen of zakelijke samenwerkingen. Wij reageren binnen één werkdag.",
  "seo.about.title": "Over Dutch DryIce",
  "seo.about.desc": "Maak kennis met Dutch DryIce: NEN-gecertificeerde droogijsleverancier met een sterke focus op kwaliteit, service en snelle levering door heel Nederland.",
  "seo.faq.title": "Veelgestelde vragen over droogijs",
  "seo.faq.desc": "Antwoorden op de meest gestelde vragen over droogijs: levering, opslag, veiligheid, prijzen en gebruik in horeca, medisch en industrieel.",
  "seo.quote.title": "Offerte aanvragen voor grootverbruik",
  "seo.quote.desc": "Vraag een offerte op maat aan voor grote droogijsvolumes (vanaf 150 kg per week). Persoonlijk advies en scherpe staffelprijzen voor zakelijke klanten.",
};

export default nl;
